/**
 * @license
 * Adobe Visitor API for JavaScript version: 5.5.0
 * Copyright 2022 Adobe, Inc. All Rights Reserved
 * More info available at https://marketing.adobe.com/resources/help/en_US/mcvid/
 */
const e = (function () {
    'use strict';
    function e(t) {
        '@babel/helpers - typeof';
        return (e =
            typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
                ? function (e) {
                      return typeof e;
                  }
                : function (e) {
                      return e && typeof Symbol === 'function' && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
                  })(t);
    }

    function t(e, t, n) {
        return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
    }

    function n() {
        return {
            callbacks: {},
            add(e, t) {
                this.callbacks[e] = this.callbacks[e] || [];
                const n = this.callbacks[e].push(t) - 1;
                const i = this;
                return function () {
                    i.callbacks[e].splice(n, 1);
                };
            },
            execute(e, t) {
                if (this.callbacks[e]) {
                    (t = void 0 === t ? [] : t), (t = t instanceof Array ? t : [t]);
                    try {
                        for (; this.callbacks[e].length; ) {
                            const n = this.callbacks[e].shift();
                            typeof n === 'function' ? n.apply(null, t) : n instanceof Array && n[1].apply(n[0], t);
                        }

                        delete this.callbacks[e];
                    } catch (e) {}
                }
            },
            executeAll(e, t) {
                (t || (e && !U.isObjectEmpty(e))) &&
                    Object.keys(this.callbacks).forEach(function (t) {
                        const n = void 0 !== e[t] ? e[t] : '';
                        this.execute(t, n);
                    }, this);
            },
            hasCallbacks() {
                return Boolean(Object.keys(this.callbacks).length);
            },
        };
    }

    function i(e, t, n) {
        const i = e == null ? void 0 : e[t];
        return void 0 === i ? n : i;
    }

    function r(e) {
        for (let t = /^\d+$/, n = 0, i = e.length; n < i; n++) if (!t.test(e[n])) return !1;
        return !0;
    }

    function a(e, t) {
        for (; e.length < t.length; ) e.push('0');
        for (; t.length < e.length; ) t.push('0');
    }

    function o(e, t) {
        for (let n = 0; n < e.length; n++) {
            const i = parseInt(e[n], 10);
            const r = parseInt(t[n], 10);
            if (i > r) return 1;
            if (r > i) return -1;
        }

        return 0;
    }

    function s(e, t) {
        if (e === t) return 0;
        const n = e.toString().split('.');
        const i = t.toString().split('.');
        return r(n.concat(i)) ? (a(n, i), o(n, i)) : NaN;
    }

    function c(e) {
        return e === Object(e) && Object.keys(e).length === 0;
    }

    function u(e) {
        return typeof e === 'function' || (e instanceof Array && e.length);
    }

    function l() {
        const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
        const t =
            arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : function () {
                      return !0;
                  };

        (this.log = Ie('log', e, t)), (this.warn = Ie('warn', e, t)), (this.error = Ie('error', e, t));
    }

    function d() {
        const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const t = e.cookieName;
        const n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const i = n.cookies;
        if (!t || !i) return { get: xe, set: xe, remove: xe };
        var r = {
            remove() {
                i.remove(t);
            },
            get() {
                const e = i.get(t);
                let n = {};
                try {
                    n = JSON.parse(e);
                } catch (e) {
                    n = {};
                }

                return n;
            },
            set(e, n) {
                n = n || {};
                const a = r.get();
                const o = Object.assign(a, e);
                i.set(t, JSON.stringify(o), {
                    domain: n.optInCookieDomain || '',
                    cookieLifetime: n.optInStorageExpiry || 3419e4,
                    secure: n.secure,
                    sameSite: n.sameSite,
                    expires: !0,
                });
            },
        };
        return r;
    }

    function f(e) {
        (this.name = this.constructor.name),
            (this.message = e),
            typeof Error.captureStackTrace === 'function' ? Error.captureStackTrace(this, this.constructor) : (this.stack = new Error(e).stack);
    }

    function p() {
        function e(e, t) {
            const n = Ae(e);
            return n.length ? n.every((e) => Boolean(t[e])) : Oe(t);
        }

        function t() {
            E(M),
                k(de.COMPLETE),
                S(C.status, C.permissions),
                s && _.set(C.permissions, { optInCookieDomain: c, optInStorageExpiry: u, secure: f, sameSite: p }),
                I.execute(He);
        }

        function n(e) {
            return function (n, i) {
                if (!Me(n)) throw new Error('[OptIn] Invalid category(-ies). Please use the `OptIn.Categories` enum.');
                return k(de.CHANGED), Object.assign(M, ke(Ae(n), e)), i || t(), C;
            };
        }

        const i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const r = i.doesOptInApply;
        const a = i.previousPermissions;
        const o = i.preOptInApprovals;
        var s = i.isOptInStorageEnabled;
        var c = i.optInCookieDomain;
        var u = i.optInStorageExpiry;
        const l = i.isIabContext;
        var f = i.secureCookie;
        var p = i.sameSiteCookie;
        const g = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const m = g.cookies;
        const h = Ne(a);
        Fe(h, 'Invalid `previousPermissions`!'), Fe(o, 'Invalid `preOptInApprovals`!');
        var _ = d({ cookieName: 'adobeujs-optin' }, { cookies: m });
        var C = this;
        var S = le(C);
        var I = _e();
        const v = Le(h);
        const D = Le(o);
        const y = s ? _.get() : {};
        const b = {};
        let A = (function (e, t) {
            return Pe(e) || (t && Pe(t)) ? de.COMPLETE : de.PENDING;
        })(v, y);
        let O = (function (e, t, n) {
            const i = ke(he, !r);
            return r ? { ...i, ...e, ...t, ...n } : i;
        })(D, v, y);
        var M = Ee(O);
        var k = function (e) {
            return (A = e);
        };

        var E = function (e) {
            return (O = e);
        };

        (C.deny = n(!1)),
            (C.approve = n(!0)),
            (C.denyAll = C.deny.bind(C, he)),
            (C.approveAll = C.approve.bind(C, he)),
            (C.isApproved = function (t) {
                return e(t, C.permissions);
            }),
            (C.isPreApproved = function (t) {
                return e(t, D);
            }),
            (C.fetchPermissions = function (e) {
                const t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = t ? C.on(de.COMPLETE, e) : xe;
                return !r || (r && C.isComplete) || Boolean(o) ? e(C.permissions) : t || I.add(He, () => e(C.permissions)), n;
            }),
            (C.complete = function () {
                C.status === de.CHANGED && t();
            }),
            (C.registerPlugin = function (e) {
                if (!e || !e.name || typeof e.onRegister !== 'function') throw new Error(Be);
                b[e.name] || ((b[e.name] = e), e.onRegister.call(e, C));
            }),
            (C.execute = Ue(b)),
            (C.memoizeContent = function (e) {
                we(e) && _.set(e, { optInCookieDomain: c, optInStorageExpiry: u, secure: f, sameSite: p });
            }),
            (C.getMemoizedContent = function (e) {
                const t = _.get();
                if (t) return t[e];
            }),
            Object.defineProperties(C, {
                permissions: {
                    get() {
                        return O;
                    },
                },
                status: {
                    get() {
                        return A;
                    },
                },
                Categories: {
                    get() {
                        return fe;
                    },
                },
                doesOptInApply: {
                    get() {
                        return Boolean(r);
                    },
                },
                isPending: {
                    get() {
                        return C.status === de.PENDING;
                    },
                },
                isComplete: {
                    get() {
                        return C.status === de.COMPLETE;
                    },
                },
                __plugins: {
                    get() {
                        return Object.keys(b);
                    },
                },
                isIabContext: {
                    get() {
                        return l;
                    },
                },
            });
    }

    function g(e, t) {
        function n() {
            (r = null), e.call(e, new f('The call took longer than you wanted!'));
        }

        function i() {
            r && (clearTimeout(r), e.apply(e, arguments));
        }

        if (void 0 === t) return e;
        var r = setTimeout(n, t);
        return i;
    }

    function m() {
        if (window.__tcfapi) return window.__tcfapi;
        let e = window;
        if (e === window.top) return void ye.error('__tcfapi not found');
        for (var t; !t; ) {
            e = e.parent;
            try {
                e.frames.__tcfapiLocator && (t = e);
            } catch (e) {}

            if (e === window.top) break;
        }

        if (!t) return void ye.error('__tcfapi not found');
        const n = {};
        return (
            (window.__tcfapi = function (e, i, r, a) {
                const o = String(Math.random());
                const s = { __tcfapiCall: { command: e, parameter: a, version: i, callId: o } };
                (n[o] = r), t.postMessage(s, '*');
            }),
            window.addEventListener(
                'message',
                (e) => {
                    let t = e.data;
                    if (typeof t === 'string')
                        try {
                            t = JSON.parse(e.data);
                        } catch (e) {}

                    if (t.__tcfapiReturn) {
                        const i = t.__tcfapiReturn;
                        typeof n[i.callId] === 'function' && (n[i.callId](i.returnValue, i.success), delete n[i.callId]);
                    }
                },
                !1
            ),
            window.__tcfapi
        );
    }

    function h(e, t) {
        const n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
        const i = !0 === e.vendor.consents[t];
        const r = n.every((t) => !0 === e.purpose.consents[t]);
        return i && r;
    }

    function _() {
        const e = this;
        (e.name = 'iabPlugin'), (e.version = '0.0.2');
        let t;
        const n = _e();
        const i = { transparencyAndConsentData: null };
        const r = function (e) {
            const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return (i[e] = t);
        };

        (e.fetchConsentData = function (e) {
            const t = e.callback;
            const n = e.timeout;
            const i = g(t, n);
            a({ callback: i });
        }),
            (e.isApproved = function (e) {
                const t = e.callback;
                const n = e.category;
                const r = e.timeout;
                if (i.transparencyAndConsentData) return t(null, h(i.transparencyAndConsentData, pe[n], ge[n]));
                const o = g((e, i) => {
                    t(e, h(i, pe[n], ge[n]));
                }, r);
                a({ category: n, callback: o });
            }),
            (e.onRegister = function (n) {
                t = n;
                const i = Object.keys(pe);
                const r = function (e, t) {
                    !e &&
                        t &&
                        (i.forEach((e) => {
                            const i = h(t, pe[e], ge[e]);
                            n[i ? 'approve' : 'deny'](e, !0);
                        }),
                        n.complete());
                };

                e.fetchConsentData({ callback: r });
            });
        var a = function (e) {
            const a = e.callback;
            if (i.transparencyAndConsentData) return a(null, i.transparencyAndConsentData);
            n.add('FETCH_CONSENT_DATA', a),
                o((e, a) => {
                    if (a) {
                        const o = Ee(e);
                        const s = t.getMemoizedContent('iabConsentHash');
                        const c = De(o.tcString).toString(32);
                        (o.consentString = e.tcString),
                            (o.hasConsentChangedSinceLastCmpPull = s !== c),
                            r('transparencyAndConsentData', o),
                            t.memoizeContent({ iabConsentHash: c });
                    }

                    n.execute('FETCH_CONSENT_DATA', [null, i.transparencyAndConsentData]);
                });
        };

        var o = function (e) {
            const t = Ve(pe);
            const n = m();
            typeof n === 'function' && n('getTCData', 2, e, t);
        };
    }

    const C =
        typeof globalThis !== 'undefined'
            ? globalThis
            : typeof window !== 'undefined'
            ? window
            : typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
            ? self
            : {};
    Object.assign =
        Object.assign ||
        function (e) {
            for (var t, n, i = 1; i < arguments.length; ++i) {
                n = arguments[i];
                for (t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
            }

            return e;
        };

    let S;
    let I;
    const v = { HANDSHAKE: 'HANDSHAKE', GETSTATE: 'GETSTATE', PARENTSTATE: 'PARENTSTATE' };
    const D = { MCMID: 'MCMID', MCAID: 'MCAID', MCAAMB: 'MCAAMB', MCAAMLH: 'MCAAMLH', MCOPTOUT: 'MCOPTOUT', CUSTOMERIDS: 'CUSTOMERIDS' };
    const y = {
        MCMID: 'getMarketingCloudVisitorID',
        MCAID: 'getAnalyticsVisitorID',
        MCAAMB: 'getAudienceManagerBlob',
        MCAAMLH: 'getAudienceManagerLocationHint',
        MCOPTOUT: 'isOptedOut',
        ALLFIELDS: 'getVisitorValues',
    };
    const b = { CUSTOMERIDS: 'getCustomerIDs' };
    const A = {
        MCMID: 'getMarketingCloudVisitorID',
        MCAAMB: 'getAudienceManagerBlob',
        MCAAMLH: 'getAudienceManagerLocationHint',
        MCOPTOUT: 'isOptedOut',
        MCAID: 'getAnalyticsVisitorID',
        CUSTOMERIDS: 'getCustomerIDs',
        ALLFIELDS: 'getVisitorValues',
    };
    const O = { MC: 'MCMID', A: 'MCAID', AAM: 'MCAAMB' };
    const M = { MCMID: 'MCMID', MCOPTOUT: 'MCOPTOUT', MCAID: 'MCAID', MCAAMLH: 'MCAAMLH', MCAAMB: 'MCAAMB' };
    const k = { UNKNOWN: 0, AUTHENTICATED: 1, LOGGED_OUT: 2 };
    const E = { GLOBAL: 'global' };
    const T = { LAX: 'Lax', STRICT: 'Strict', NONE: 'None' };
    const L = {
        MESSAGES: v,
        STATE_KEYS_MAP: D,
        ASYNC_API_MAP: y,
        SYNC_API_MAP: b,
        ALL_APIS: A,
        FIELDGROUP_TO_FIELD: O,
        FIELDS: M,
        AUTH_STATE: k,
        OPT_OUT: E,
        SAME_SITE_VALUES: T,
    };
    const P = L.STATE_KEYS_MAP;
    const R = function (e) {
        function t() {}
        function n(t, n) {
            const i = this;
            return function () {
                const r = e(0, t);
                const a = {};
                return (a[t] = r), i.setStateAndPublish(a), n(r), r;
            };
        }

        (this.getMarketingCloudVisitorID = function (e) {
            e = e || t;
            const i = this.findField(P.MCMID, e);
            const r = n.call(this, P.MCMID, e);
            return void 0 !== i ? i : r();
        }),
            (this.getVisitorValues = function (e) {
                this.getMarketingCloudVisitorID((t) => {
                    e({ MCMID: t });
                });
            });
    };

    const w = L.MESSAGES;
    const x = L.ASYNC_API_MAP;
    const N = L.SYNC_API_MAP;
    const F = function () {
        function e() {}
        function t(e, t) {
            const n = this;
            return function () {
                return n.callbackRegistry.add(e, t), n.messageParent(w.GETSTATE), '';
            };
        }

        function n(n) {
            this[x[n]] = function (i) {
                i = i || e;
                const r = this.findField(n, i);
                const a = t.call(this, n, i);
                return void 0 !== r ? r : a();
            };
        }

        function i(t) {
            this[N[t]] = function () {
                return this.findField(t, e) || {};
            };
        }

        Object.keys(x).forEach(n, this), Object.keys(N).forEach(i, this);
    };

    const j = L.ASYNC_API_MAP;
    const V = function () {
        Object.keys(j).forEach(function (e) {
            this[j[e]] = function (t) {
                this.callbackRegistry.add(e, t);
            };
        }, this);
    };

    var U = (function (e, t) {
        return (t = { exports: {} }), e(t, t.exports), t.exports;
    })((t, n) => {
        (n.isObjectEmpty = function (e) {
            return e === Object(e) && Object.keys(e).length === 0;
        }),
            (n.isValueEmpty = function (e) {
                return e === '' || n.isObjectEmpty(e);
            });
        const i = function () {
            const e = navigator.appName;
            const t = navigator.userAgent;
            return e === 'Microsoft Internet Explorer' || t.indexOf('MSIE ') >= 0 || (t.indexOf('Trident/') >= 0 && t.indexOf('Windows NT 6') >= 0);
        };

        (n.getIeVersion = function () {
            return document.documentMode ? document.documentMode : i() ? 7 : null;
        }),
            (n.isFirefox = function (e) {
                return Boolean(/Firefox\/([0-9\.]+)(?:\s|$)/.test(e || window.navigator.userAgent));
            }),
            (n.encodeAndBuildRequest = function (e, t) {
                return e.map(encodeURIComponent).join(t);
            }),
            (n.isObject = function (t) {
                return t !== null && e(t) === 'object' && !1 === Array.isArray(t);
            }),
            (n.defineGlobalNamespace = function () {
                return (window.adobe = n.isObject(window.adobe) ? window.adobe : {}), window.adobe;
            }),
            (n.pluck = function (e, t) {
                return t.reduce((t, n) => (e[n] && (t[n] = e[n]), t), Object.create(null));
            }),
            (n.parseOptOut = function (e, t, n) {
                t || ((t = n), e.d_optout && e.d_optout instanceof Array && (t = e.d_optout.join(',')));
                let i = parseInt(e.d_ottl, 10);
                return isNaN(i) && (i = 7200), { optOut: t, d_ottl: i };
            }),
            (n.normalizeBoolean = function (e) {
                let t = e;
                return e === 'true' ? (t = !0) : e === 'false' && (t = !1), t;
            });
    });
    const H =
        (U.isObjectEmpty,
        U.isValueEmpty,
        U.getIeVersion,
        U.isFirefox,
        U.encodeAndBuildRequest,
        U.isObject,
        U.defineGlobalNamespace,
        U.pluck,
        U.parseOptOut,
        U.normalizeBoolean,
        n);
    const B = L.MESSAGES;
    const G = { 0: 'prefix', 1: 'orgID', 2: 'state' };
    const Y = function (e, t) {
        (this.parse = function (e) {
            try {
                const t = {};
                return (
                    e.data.split('|').forEach((e, n) => {
                        if (void 0 !== e) {
                            t[G[n]] = n !== 2 ? e : JSON.parse(e);
                        }
                    }),
                    t
                );
            } catch (e) {}
        }),
            (this.isInvalid = function (n) {
                const i = this.parse(n);
                if (!i || Object.keys(i).length < 2) return !0;
                const r = e !== i.orgID;
                const a = !t || n.origin !== t;
                const o = Object.keys(B).indexOf(i.prefix) === -1;
                return r || a || o;
            }),
            (this.send = function (n, i, r) {
                let a = i + '|' + e;
                r && r === Object(r) && (a += '|' + JSON.stringify(r));
                try {
                    n.postMessage(a, t);
                } catch (e) {}
            });
    };

    const q = L.MESSAGES;
    const W = function (e, t, n, i) {
        function r(e) {
            Object.assign(p, e);
        }

        function a(e) {
            Object.assign(p.state, e), Object.assign(p.state.ALLFIELDS, e), p.callbackRegistry.executeAll(p.state);
        }

        function o(e) {
            if (!h.isInvalid(e)) {
                m = !1;
                const t = h.parse(e);
                p.setStateAndPublish(t.state);
            }
        }

        function s(e) {
            !m && g && ((m = !0), h.send(i, e));
        }

        function c() {
            r(new R(n._generateID)), p.getMarketingCloudVisitorID(), p.callbackRegistry.executeAll(p.state, !0), C.removeEventListener('message', u);
        }

        function u(e) {
            if (!h.isInvalid(e)) {
                const t = h.parse(e);
                (m = !1),
                    C.clearTimeout(p._handshakeTimeout),
                    C.removeEventListener('message', u),
                    r(new F(p)),
                    C.addEventListener('message', o),
                    p.setStateAndPublish(t.state),
                    p.callbackRegistry.hasCallbacks() && s(q.GETSTATE);
            }
        }

        function l() {
            g && postMessage ? (C.addEventListener('message', u), s(q.HANDSHAKE), (p._handshakeTimeout = setTimeout(c, 250))) : c();
        }

        function d() {
            C.s_c_in || ((C.s_c_il = []), (C.s_c_in = 0)), (p._c = 'Visitor'), (p._il = C.s_c_il), (p._in = C.s_c_in), (p._il[p._in] = p), C.s_c_in++;
        }

        function f() {
            function e(e) {
                e.indexOf('_') !== 0 && typeof n[e] === 'function' && (p[e] = function () {});
            }

            Object.keys(n).forEach(e),
                (p.getSupplementalDataID = n.getSupplementalDataID),
                (p.isAllowed = function () {
                    return !0;
                });
        }

        var p = this;
        var g = t.whitelistParentDomain;
        (p.state = { ALLFIELDS: {} }),
            (p.version = n.version),
            (p.marketingCloudOrgID = e),
            (p.cookieDomain = n.cookieDomain || ''),
            (p._instanceType = 'child');
        var m = !1;
        var h = new Y(e, g);
        (p.callbackRegistry = H()),
            (p.init = function () {
                d(), f(), r(new V(p)), l();
            }),
            (p.findField = function (e, t) {
                if (void 0 !== p.state[e]) return t(p.state[e]), p.state[e];
            }),
            (p.messageParent = s),
            (p.setStateAndPublish = a);
    };

    const X = L.MESSAGES;
    const K = L.ALL_APIS;
    const J = L.ASYNC_API_MAP;
    const z = L.FIELDGROUP_TO_FIELD;
    const Q = function (e, t) {
        function n() {
            const t = {};
            return (
                Object.keys(K).forEach((n) => {
                    const i = K[n];
                    const r = e[i]();
                    U.isValueEmpty(r) || (t[n] = r);
                }),
                t
            );
        }

        function i() {
            const t = [];
            return (
                e._loading &&
                    Object.keys(e._loading).forEach((n) => {
                        if (e._loading[n]) {
                            const i = z[n];
                            t.push(i);
                        }
                    }),
                t.length ? t : null
            );
        }

        function r(t) {
            return function n(r) {
                const a = i();
                if (a) {
                    const o = J[a[0]];
                    e[o](n, !0);
                } else t();
            };
        }

        function a(e, i) {
            const r = n();
            t.send(e, i, r);
        }

        function o(e) {
            c(e), a(e, X.HANDSHAKE);
        }

        function s(e) {
            r(() => {
                a(e, X.PARENTSTATE);
            })();
        }

        function c(n) {
            function i(i) {
                r.call(e, i), t.send(n, X.PARENTSTATE, { CUSTOMERIDS: e.getCustomerIDs() });
            }

            var r = e.setCustomerIDs;
            e.setCustomerIDs = i;
        }

        return function (e) {
            if (!t.isInvalid(e)) {
                (t.parse(e).prefix === X.HANDSHAKE ? o : s)(e.source);
            }
        };
    };

    const $ = function (e, t) {
        function n(e) {
            return function (n) {
                (i[e] = n), r++, r === a && t(i);
            };
        }

        var i = {};
        var r = 0;
        var a = Object.keys(e).length;
        Object.keys(e).forEach((t) => {
            const i = e[t];
            if (i.fn) {
                const r = i.args || [];
                r.unshift(n(t)), i.fn.apply(i.context || null, r);
            }
        });
    };

    const Z = {
        get(e) {
            e = encodeURIComponent(e);
            const t = (';' + document.cookie).split(' ').join(';');
            const n = t.indexOf(';' + e + '=');
            const i = n < 0 ? n : t.indexOf(';', n + 1);
            return n < 0 ? '' : decodeURIComponent(t.substring(n + 2 + e.length, i < 0 ? t.length : i));
        },
        set(e, t, n) {
            const r = i(n, 'cookieLifetime');
            let a = i(n, 'expires');
            const o = i(n, 'domain');
            const s = i(n, 'secure');
            const c = i(n, 'sameSite');
            const u = s ? 'Secure' : '';
            const l = c ? 'SameSite=' + c + ';' : '';
            if (a && r !== 'SESSION' && r !== 'NONE') {
                const d = t !== '' ? parseInt(r || 0, 10) : -60;
                if (d) (a = new Date()), a.setTime(a.getTime() + 1e3 * d);
                else if (a === 1) {
                    a = new Date();
                    const f = a.getYear();
                    a.setYear(f + 2 + (f < 1900 ? 1900 : 0));
                }
            } else a = 0;
            return e && r !== 'NONE'
                ? ((document.cookie =
                      encodeURIComponent(e) +
                      '=' +
                      encodeURIComponent(t) +
                      '; path=/;' +
                      (a ? ' expires=' + a.toGMTString() + ';' : '') +
                      (o ? ' domain=' + o + ';' : '') +
                      l +
                      u),
                  this.get(e) === t)
                : 0;
        },
        remove(e, t) {
            let n = i(t, 'domain');
            n = n ? ' domain=' + n + ';' : '';
            const r = i(t, 'secure');
            const a = i(t, 'sameSite');
            const o = r ? 'Secure' : '';
            const s = a ? 'SameSite=' + a + ';' : '';
            document.cookie = encodeURIComponent(e) + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;' + n + s + o;
        },
    };
    const ee = function (e, t) {
        let n;
        !e && C.location && (e = C.location.hostname), (n = e);
        let i;
        const r = n.split('.');
        const a = t || {};
        for (i = r.length - 2; i >= 0; i--)
            if (((a.domain = r.slice(i).join('.')), Z.set('TEST_AMCV_COOKIE_WRITE', 'cookie', a)))
                return Z.remove('TEST_AMCV_COOKIE_WRITE', a), a.domain;
        return '';
    };

    const te = {
        compare: s,
        isLessThan(e, t) {
            return s(e, t) < 0;
        },
        areVersionsDifferent(e, t) {
            return s(e, t) !== 0;
        },
        isGreaterThan(e, t) {
            return s(e, t) > 0;
        },
        isEqual(e, t) {
            return s(e, t) === 0;
        },
    };
    const ne = Boolean(C.postMessage);
    const ie = {
        postMessage(e, t, n) {
            let i = 1;
            t &&
                (ne
                    ? n.postMessage(e, t.replace(/([^:]+:\/\/[^\/]+).*/, '$1'))
                    : t && (n.location = t.replace(/#.*$/, '') + '#' + Number(new Date()) + i++ + '&' + e));
        },
        receiveMessage(e, t) {
            let n;
            try {
                ne &&
                    (e &&
                        (n = function (n) {
                            if (
                                (typeof t === 'string' && n.origin !== t) ||
                                (Object.prototype.toString.call(t) === '[object Function]' && !1 === t(n.origin))
                            )
                                return !1;
                            e(n);
                        }),
                    C.addEventListener
                        ? C[e ? 'addEventListener' : 'removeEventListener']('message', n)
                        : C[e ? 'attachEvent' : 'detachEvent']('onmessage', n));
            } catch (e) {}
        },
    };
    const re = function (e) {
        let t;
        let n;
        let i = '0123456789';
        let r = '';
        let a = '';
        let o = 8;
        let s = 10;
        let c = 10;
        const u = String(Date.now());
        const l = u.substr(-6).split('').reverse('').join('');
        if (e == 1) {
            for (i += 'ABCDEF', t = 0; t < 16; t++)
                (n = Math.floor(Math.random() * o)),
                    t < 4 && l[t] < o && (n = Number(l[t])),
                    (r += i.substring(n, n + 1)),
                    (n = Math.floor(Math.random() * o)),
                    (a += i.substring(n, n + 1)),
                    (o = 16);
            return r + '-' + a;
        }

        for (t = 0; t < 19; t++)
            (n = Math.floor(Math.random() * s)),
                t < 6 && l[t] < s ? ((r += l[t]), (n = l[t])) : (r += i.substring(n, n + 1)),
                t === 0 && n == 9 ? (s = 3) : (t == 1 || t == 2) && s != 10 && n < 2 ? (s = 10) : t > 2 && (s = 10),
                (n = Math.floor(Math.random() * c)),
                (a += i.substring(n, n + 1)),
                t === 0 && n == 9 ? (c = 3) : (t == 1 || t == 2) && c != 10 && n < 2 ? (c = 10) : t > 2 && (c = 10);
        return r + a;
    };

    const ae = function (e, t) {
        return {
            corsMetadata: (function () {
                let e = 'none';
                let t = !0;
                return (
                    typeof XMLHttpRequest !== 'undefined' &&
                        XMLHttpRequest === Object(XMLHttpRequest) &&
                        ('withCredentials' in new XMLHttpRequest()
                            ? (e = 'XMLHttpRequest')
                            : typeof XDomainRequest !== 'undefined' && XDomainRequest === Object(XDomainRequest) && (t = !1),
                        Object.prototype.toString.call(C.HTMLElement).indexOf('Constructor') > 0 && (t = !1)),
                    { corsType: e, corsCookiesEnabled: t }
                );
            })(),
            getCORSInstance() {
                return this.corsMetadata.corsType === 'none' ? null : new C[this.corsMetadata.corsType]();
            },
            fireCORS(t, n, i) {
                function r(e) {
                    let n;
                    try {
                        if ((n = JSON.parse(e)) !== Object(n)) return void a.handleCORSError(t, null, 'Response is not JSON');
                    } catch (e) {
                        return void a.handleCORSError(t, e, 'Error parsing response as JSON');
                    }

                    try {
                        for (var i = t.callback, r = C, o = 0; o < i.length; o++) r = r[i[o]];
                        r(n);
                    } catch (e) {
                        a.handleCORSError(t, e, 'Error forming callback function');
                    }
                }

                var a = this;
                n && (t.loadErrorHandler = n);
                try {
                    const o = this.getCORSInstance();
                    o.open('get', t.corsUrl + '&ts=' + new Date().getTime(), !0),
                        this.corsMetadata.corsType === 'XMLHttpRequest' &&
                            ((o.withCredentials = !0),
                            (o.timeout = e.loadTimeout),
                            o.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'),
                            (o.onreadystatechange = function () {
                                this.readyState === 4 && this.status === 200 && r(this.responseText);
                            })),
                        (o.onerror = function (e) {
                            a.handleCORSError(t, e, 'onerror');
                        }),
                        (o.ontimeout = function (e) {
                            a.handleCORSError(t, e, 'ontimeout');
                        }),
                        o.send(),
                        e._log.requests.push(t.corsUrl);
                } catch (e) {
                    this.handleCORSError(t, e, 'try-catch');
                }
            },
            handleCORSError(t, n, i) {
                e.CORSErrors.push({ corsData: t, error: n, description: i }),
                    t.loadErrorHandler && (i === 'ontimeout' ? t.loadErrorHandler(!0) : t.loadErrorHandler(!1));
            },
        };
    };

    const oe = {
        POST_MESSAGE_ENABLED: Boolean(C.postMessage),
        DAYS_BETWEEN_SYNC_ID_CALLS: 1,
        MILLIS_PER_DAY: 864e5,
        ADOBE_MC: 'adobe_mc',
        ADOBE_MC_SDID: 'adobe_mc_sdid',
        VALID_VISITOR_ID_REGEX: /^[0-9a-fA-F\-]+$/,
        ADOBE_MC_TTL_IN_MIN: 5,
        VERSION_REGEX: /vVersion\|((\d+\.)?(\d+\.)?(\*|\d+))(?=$|\|)/,
        FIRST_PARTY_SERVER_COOKIE: 's_ecid',
    };
    const se = function (e, t) {
        const n = C.document;
        return {
            THROTTLE_START: 3e4,
            MAX_SYNCS_LENGTH: 649,
            throttleTimerSet: !1,
            id: null,
            onPagePixels: [],
            iframeHost: null,
            getIframeHost(e) {
                if (typeof e === 'string') {
                    const t = e.split('/');
                    return t[0] + '//' + t[2];
                }
            },
            subdomain: null,
            url: null,
            getUrl() {
                let t;
                let i = 'http://fast.';
                const r = '?d_nsid=' + e.idSyncContainerID + '#' + encodeURIComponent(n.location.origin);
                return (
                    this.subdomain || (this.subdomain = 'nosubdomainreturned'),
                    e.loadSSL && (i = e.idSyncSSLUseAkamai ? 'https://fast.' : 'https://'),
                    (t = i + this.subdomain + '.demdex.net/dest5.html' + r),
                    (this.iframeHost = this.getIframeHost(t)),
                    (this.id = 'destination_publishing_iframe_' + this.subdomain + '_' + e.idSyncContainerID),
                    t
                );
            },
            checkDPIframeSrc() {
                const t = '?d_nsid=' + e.idSyncContainerID + '#' + encodeURIComponent(n.location.href);
                typeof e.dpIframeSrc === 'string' &&
                    e.dpIframeSrc.length &&
                    ((this.id =
                        'destination_publishing_iframe_' + (e._subdomain || this.subdomain || new Date().getTime()) + '_' + e.idSyncContainerID),
                    (this.iframeHost = this.getIframeHost(e.dpIframeSrc)),
                    (this.url = e.dpIframeSrc + t));
            },
            idCallNotProcesssed: null,
            doAttachIframe: !1,
            startedAttachingIframe: !1,
            iframeHasLoaded: null,
            iframeIdChanged: null,
            newIframeCreated: null,
            originalIframeHasLoadedAlready: null,
            iframeLoadedCallbacks: [],
            regionChanged: !1,
            timesRegionChanged: 0,
            sendingMessages: !1,
            messages: [],
            messagesPosted: [],
            messagesReceived: [],
            messageSendingInterval: oe.POST_MESSAGE_ENABLED ? null : 100,
            onPageDestinationsFired: [],
            jsonForComparison: [],
            jsonDuplicates: [],
            jsonWaiting: [],
            jsonProcessed: [],
            canSetThirdPartyCookies: !0,
            receivedThirdPartyCookiesNotification: !1,
            readyToAttachIframePreliminary() {
                return !(
                    e.idSyncDisableSyncs ||
                    e.disableIdSyncs ||
                    e.idSyncDisable3rdPartySyncing ||
                    e.disableThirdPartyCookies ||
                    e.disableThirdPartyCalls
                );
            },
            readyToAttachIframe() {
                return (
                    this.readyToAttachIframePreliminary() &&
                    (this.doAttachIframe || e._doAttachIframe) &&
                    ((this.subdomain && this.subdomain !== 'nosubdomainreturned') || e._subdomain) &&
                    this.url &&
                    !this.startedAttachingIframe
                );
            },
            attachIframe() {
                function e() {
                    (r = n.createElement('iframe')),
                        (r.sandbox = 'allow-scripts allow-same-origin'),
                        (r.title = 'Adobe ID Syncing iFrame'),
                        (r.id = i.id),
                        (r.name = i.id + '_name'),
                        (r.style.cssText = 'display: none; width: 0; height: 0;'),
                        (r.src = i.url),
                        (i.newIframeCreated = !0),
                        t(),
                        n.body.appendChild(r);
                }

                function t(e) {
                    r.addEventListener('load', () => {
                        (r.className = 'aamIframeLoaded'), (i.iframeHasLoaded = !0), i.fireIframeLoadedCallbacks(e), i.requestToProcess();
                    });
                }

                this.startedAttachingIframe = !0;
                var i = this;
                var r = n.getElementById(this.id);
                r
                    ? r.nodeName !== 'IFRAME'
                        ? ((this.id += '_2'), (this.iframeIdChanged = !0), e())
                        : ((this.newIframeCreated = !1),
                          r.className !== 'aamIframeLoaded'
                              ? ((this.originalIframeHasLoadedAlready = !1),
                                t("The destination publishing iframe already exists from a different library, but hadn't loaded yet."))
                              : ((this.originalIframeHasLoadedAlready = !0),
                                (this.iframeHasLoaded = !0),
                                (this.iframe = r),
                                this.fireIframeLoadedCallbacks(
                                    'The destination publishing iframe already exists from a different library, and had loaded alresady.'
                                ),
                                this.requestToProcess()))
                    : e(),
                    (this.iframe = r);
            },
            fireIframeLoadedCallbacks(e) {
                this.iframeLoadedCallbacks.forEach((t) => {
                    typeof t === 'function' && t({ message: e || 'The destination publishing iframe was attached and loaded successfully.' });
                }),
                    (this.iframeLoadedCallbacks = []);
            },
            requestToProcess(t) {
                function n() {
                    r.jsonForComparison.push(t), r.jsonWaiting.push(t), r.processSyncOnPage(t);
                }

                let i;
                var r = this;
                if (t === Object(t) && t.ibs)
                    if (((i = JSON.stringify(t.ibs || [])), this.jsonForComparison.length)) {
                        let a;
                        let o;
                        let s;
                        let c = !1;
                        for (a = 0, o = this.jsonForComparison.length; a < o; a++)
                            if (((s = this.jsonForComparison[a]), i === JSON.stringify(s.ibs || []))) {
                                c = !0;
                                break;
                            }

                        c ? this.jsonDuplicates.push(t) : n();
                    } else n();
                if ((this.receivedThirdPartyCookiesNotification || !oe.POST_MESSAGE_ENABLED || this.iframeHasLoaded) && this.jsonWaiting.length) {
                    const u = this.jsonWaiting.shift();
                    this.process(u), this.requestToProcess();
                }

                e.idSyncDisableSyncs ||
                    e.disableIdSyncs ||
                    !this.iframeHasLoaded ||
                    !this.messages.length ||
                    this.sendingMessages ||
                    (this.throttleTimerSet ||
                        ((this.throttleTimerSet = !0),
                        setTimeout(() => {
                            r.messageSendingInterval = oe.POST_MESSAGE_ENABLED ? null : 150;
                        }, this.THROTTLE_START)),
                    (this.sendingMessages = !0),
                    this.sendMessages());
            },
            getRegionAndCheckIfChanged(t, n) {
                let i = e._getField('MCAAMLH');
                const r = t.d_region || t.dcs_region;
                return (
                    i
                        ? r &&
                          (e._setFieldExpire('MCAAMLH', n),
                          e._setField('MCAAMLH', r),
                          parseInt(i, 10) !== r &&
                              ((this.regionChanged = !0),
                              this.timesRegionChanged++,
                              e._setField('MCSYNCSOP', ''),
                              e._setField('MCSYNCS', ''),
                              (i = r)))
                        : (i = r) && (e._setFieldExpire('MCAAMLH', n), e._setField('MCAAMLH', i)),
                    i || (i = ''),
                    i
                );
            },
            processSyncOnPage(e) {
                let t;
                let n;
                let i;
                let r;
                if ((t = e.ibs) && t instanceof Array && (n = t.length))
                    for (i = 0; i < n; i++) (r = t[i]), r.syncOnPage && this.checkFirstPartyCookie(r, '', 'syncOnPage');
            },
            process(e) {
                let t;
                let n;
                let i;
                let r;
                let a;
                const o = encodeURIComponent;
                let s = !1;
                if ((t = e.ibs) && t instanceof Array && (n = t.length))
                    for (s = !0, i = 0; i < n; i++)
                        (r = t[i]),
                            (a = [
                                o('ibs'),
                                o(r.id || ''),
                                o(r.tag || ''),
                                U.encodeAndBuildRequest(r.url || [], ','),
                                o(r.ttl || ''),
                                '',
                                '',
                                r.fireURLSync ? 'true' : 'false',
                            ]),
                            r.syncOnPage ||
                                (this.canSetThirdPartyCookies
                                    ? this.addMessage(a.join('|'))
                                    : r.fireURLSync && this.checkFirstPartyCookie(r, a.join('|')));
                s && this.jsonProcessed.push(e);
            },
            checkFirstPartyCookie(t, n, i) {
                const r = i === 'syncOnPage';
                const a = r ? 'MCSYNCSOP' : 'MCSYNCS';
                e._readVisitor();
                let o;
                let s;
                const c = e._getField(a);
                let u = !1;
                let l = !1;
                const d = Math.ceil(new Date().getTime() / oe.MILLIS_PER_DAY);
                c
                    ? ((o = c.split('*')),
                      (s = this.pruneSyncData(o, t.id, d)),
                      (u = s.dataPresent),
                      (l = s.dataValid),
                      (u && l) || this.fireSync(r, t, n, o, a, d))
                    : ((o = []), this.fireSync(r, t, n, o, a, d));
            },
            pruneSyncData(e, t, n) {
                let i;
                let r;
                let a;
                let o = !1;
                let s = !1;
                for (r = 0; r < e.length; r++)
                    (i = e[r]),
                        (a = parseInt(i.split('-')[1], 10)),
                        i.match('^' + t + '-') ? ((o = !0), n < a ? (s = !0) : (e.splice(r, 1), r--)) : n >= a && (e.splice(r, 1), r--);
                return { dataPresent: o, dataValid: s };
            },
            manageSyncsSize(e) {
                if (e.join('*').length > this.MAX_SYNCS_LENGTH)
                    for (
                        e.sort((e, t) => parseInt(e.split('-')[1], 10) - parseInt(t.split('-')[1], 10));
                        e.join('*').length > this.MAX_SYNCS_LENGTH;

                    )
                        e.shift();
            },
            fireSync(t, n, i, r, a, o) {
                const s = this;
                if (t) {
                    if (n.tag === 'img') {
                        let c;
                        let u;
                        let l;
                        let d;
                        const f = n.url;
                        const p = e.loadSSL ? 'https:' : 'http:';
                        for (c = 0, u = f.length; c < u; c++) {
                            (l = f[c]), (d = /^\/\//.test(l));
                            const g = new Image();
                            g.addEventListener(
                                'load',
                                (function (t, n, i, r) {
                                    return function () {
                                        (s.onPagePixels[t] = null), e._readVisitor();
                                        let o;
                                        const c = e._getField(a);
                                        const u = [];
                                        if (c) {
                                            o = c.split('*');
                                            let l;
                                            let d;
                                            let f;
                                            for (l = 0, d = o.length; l < d; l++) (f = o[l]), f.match('^' + n.id + '-') || u.push(f);
                                        }

                                        s.setSyncTrackingData(u, n, i, r);
                                    };
                                })(this.onPagePixels.length, n, a, o)
                            ),
                                (g.src = (d ? p : '') + l),
                                this.onPagePixels.push(g);
                        }
                    }
                } else this.addMessage(i), this.setSyncTrackingData(r, n, a, o);
            },
            addMessage(t) {
                const n = encodeURIComponent;
                const i = n(e._enableErrorReporting ? '---destpub-debug---' : '---destpub---');
                this.messages.push((oe.POST_MESSAGE_ENABLED ? '' : i) + t);
            },
            setSyncTrackingData(t, n, i, r) {
                t.push(n.id + '-' + (r + Math.ceil(n.ttl / 60 / 24))), this.manageSyncsSize(t), e._setField(i, t.join('*'));
            },
            sendMessages() {
                let e;
                const t = this;
                let n = '';
                const i = encodeURIComponent;
                this.regionChanged && ((n = i('---destpub-clear-dextp---')), (this.regionChanged = !1)),
                    this.messages.length
                        ? oe.POST_MESSAGE_ENABLED
                            ? ((e = n + i('---destpub-combined---') + this.messages.join('%01')),
                              this.postMessage(e),
                              (this.messages = []),
                              (this.sendingMessages = !1))
                            : ((e = this.messages.shift()),
                              this.postMessage(n + e),
                              setTimeout(() => {
                                  t.sendMessages();
                              }, this.messageSendingInterval))
                        : (this.sendingMessages = !1);
            },
            postMessage(e) {
                ie.postMessage(e, this.url, this.iframe.contentWindow), this.messagesPosted.push(e);
            },
            receiveMessage(e) {
                let t;
                const n = /^---destpub-to-parent---/;
                typeof e === 'string' &&
                    n.test(e) &&
                    ((t = e.replace(n, '').split('|')),
                    t[0] === 'canSetThirdPartyCookies' &&
                        ((this.canSetThirdPartyCookies = t[1] === 'true'),
                        (this.receivedThirdPartyCookiesNotification = !0),
                        this.requestToProcess()),
                    this.messagesReceived.push(e));
            },
            processIDCallData(i) {
                (this.url == null || (i.subdomain && this.subdomain === 'nosubdomainreturned')) &&
                    (typeof e._subdomain === 'string' && e._subdomain.length ? (this.subdomain = e._subdomain) : (this.subdomain = i.subdomain || ''),
                    (this.url = this.getUrl())),
                    i.ibs instanceof Array && i.ibs.length && (this.doAttachIframe = !0),
                    this.readyToAttachIframe() &&
                        (e.idSyncAttachIframeOnWindowLoad
                            ? (t.windowLoaded || n.readyState === 'complete' || n.readyState === 'loaded') && this.attachIframe()
                            : this.attachIframeASAP()),
                    typeof e.idSyncIDCallResult === 'function' ? e.idSyncIDCallResult(i) : this.requestToProcess(i),
                    typeof e.idSyncAfterIDCallResult === 'function' && e.idSyncAfterIDCallResult(i);
            },
            canMakeSyncIDCall(t, n) {
                return e._forceSyncIDCall || !t || n - t > oe.DAYS_BETWEEN_SYNC_ID_CALLS;
            },
            attachIframeASAP() {
                function e() {
                    t.startedAttachingIframe || (n.body ? t.attachIframe() : setTimeout(e, 30));
                }

                var t = this;
                e();
            },
        };
    };

    const ce = {
        audienceManagerServer: {},
        audienceManagerServerSecure: {},
        cookieDomain: {},
        cookieLifetime: {},
        cookieName: {},
        doesOptInApply: { type: 'boolean' },
        disableThirdPartyCalls: { type: 'boolean' },
        discardTrackingServerECID: { type: 'boolean' },
        idSyncAfterIDCallResult: {},
        idSyncAttachIframeOnWindowLoad: { type: 'boolean' },
        idSyncContainerID: {},
        idSyncDisable3rdPartySyncing: { type: 'boolean' },
        disableThirdPartyCookies: { type: 'boolean' },
        idSyncDisableSyncs: { type: 'boolean' },
        disableIdSyncs: { type: 'boolean' },
        idSyncIDCallResult: {},
        idSyncSSLUseAkamai: { type: 'boolean' },
        isCoopSafe: { type: 'boolean' },
        isIabContext: { type: 'boolean' },
        isOptInStorageEnabled: { type: 'boolean' },
        loadSSL: { type: 'boolean' },
        loadTimeout: {},
        marketingCloudServer: {},
        marketingCloudServerSecure: {},
        optInCookieDomain: {},
        optInStorageExpiry: {},
        overwriteCrossDomainMCIDAndAID: { type: 'boolean' },
        preOptInApprovals: {},
        previousPermissions: {},
        resetBeforeVersion: {},
        sdidParamExpiry: {},
        serverState: {},
        sessionCookieName: {},
        secureCookie: { type: 'boolean' },
        sameSiteCookie: {},
        takeTimeoutMetrics: {},
        trackingServer: {},
        trackingServerSecure: {},
        useLocalStorage: { type: 'boolean' },
        whitelistIframeDomains: {},
        whitelistParentDomain: {},
    };
    const ue = {
        getConfigNames() {
            return Object.keys(ce);
        },
        getConfigs() {
            return ce;
        },
        normalizeConfig(e, t) {
            return ce[e] && ce[e].type === 'boolean' ? (typeof t !== 'function' ? t : t()) : t;
        },
    };
    var le = function (e) {
        const t = {};
        return (
            (e.on = function (e, n, i) {
                if (!n || typeof n !== 'function') throw new Error('[ON] Callback should be a function.');
                t.hasOwnProperty(e) || (t[e] = []);
                const r = t[e].push({ callback: n, context: i }) - 1;
                return function () {
                    t[e].splice(r, 1), t[e].length || delete t[e];
                };
            }),
            (e.off = function (e, n) {
                t.hasOwnProperty(e) &&
                    (t[e] = t[e].filter((e) => {
                        if (e.callback !== n) return e;
                    }));
            }),
            (e.publish = function (e) {
                if (t.hasOwnProperty(e)) {
                    const n = [].slice.call(arguments, 1);
                    t[e].slice(0).forEach((e) => {
                        e.callback.apply(e.context, n);
                    });
                }
            }),
            e.publish
        );
    };

    var de = { PENDING: 'pending', CHANGED: 'changed', COMPLETE: 'complete' };
    var fe = {
        AAM: 'aam',
        ADCLOUD: 'adcloud',
        ANALYTICS: 'aa',
        CAMPAIGN: 'campaign',
        ECID: 'ecid',
        LIVEFYRE: 'livefyre',
        TARGET: 'target',
        MEDIA_ANALYTICS: 'mediaaa',
    };
    var pe = ((S = {}), t(S, fe.AAM, 565), t(S, fe.ECID, 565), S);
    var ge = ((I = {}), t(I, fe.AAM, [1, 10]), t(I, fe.ECID, [1, 10]), I);
    const me = ['videoaa', 'iabConsentHash'];
    var he = (function (e) {
        return Object.keys(e).map((t) => e[t]);
    })(fe);
    var _e = function () {
        const e = {};
        return (
            (e.callbacks = Object.create(null)),
            (e.add = function (t, n) {
                if (!u(n)) throw new Error('[callbackRegistryFactory] Make sure callback is a function or an array of functions.');
                e.callbacks[t] = e.callbacks[t] || [];
                const i = e.callbacks[t].push(n) - 1;
                return function () {
                    e.callbacks[t].splice(i, 1);
                };
            }),
            (e.execute = function (t, n) {
                if (e.callbacks[t]) {
                    (n = void 0 === n ? [] : n), (n = n instanceof Array ? n : [n]);
                    try {
                        for (; e.callbacks[t].length; ) {
                            const i = e.callbacks[t].shift();
                            typeof i === 'function' ? i.apply(null, n) : i instanceof Array && i[1].apply(i[0], n);
                        }

                        delete e.callbacks[t];
                    } catch (e) {}
                }
            }),
            (e.executeAll = function (t, n) {
                (n || (t && !c(t))) &&
                    Object.keys(e.callbacks).forEach((n) => {
                        const i = void 0 !== t[n] ? t[n] : '';
                        e.execute(n, i);
                    }, e);
            }),
            (e.hasCallbacks = function () {
                return Boolean(Object.keys(e.callbacks).length);
            }),
            e
        );
    };

    const Ce = function () {};
    const Se = function (e) {
        const t = window;
        const n = t.console;
        return Boolean(n) && typeof n[e] === 'function';
    };

    var Ie = function (e, t, n) {
        return n()
            ? function () {
                  if (Se(e)) {
                      for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) i[r] = arguments[r];
                      console[e].apply(console, [t].concat(i));
                  }
              }
            : Ce;
    };

    const ve = l;
    var De = (function () {
        for (var e = [], t = 0; t < 256; t++) {
            for (var n = t, i = 0; i < 8; i++) n = 1 & n ? 3988292384 ^ (n >>> 1) : n >>> 1;
            e.push(n);
        }

        return function (t, n) {
            (t = unescape(encodeURIComponent(t))), n || (n = 0), (n ^= -1);
            for (let i = 0; i < t.length; i++) {
                const r = 255 & (n ^ t.charCodeAt(i));
                n = (n >>> 8) ^ e[r];
            }

            return (n ^= -1) >>> 0;
        };
    })();
    var ye = new ve('[ADOBE OPT-IN]');
    const be = function (t, n) {
        return e(t) === n;
    };

    var Ae = function (e, t) {
        return e instanceof Array ? e : be(e, 'string') ? [e] : t || [];
    };

    var Oe = function (e) {
        const t = Object.keys(e);
        return Boolean(t.length) && t.every((t) => !0 === e[t]);
    };

    var Me = function (e) {
        const t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return !(!e || Te(e)) && Ae(e).every((e) => he.indexOf(e) > -1 || (t && me.indexOf(e) > -1));
    };

    var ke = function (e, t) {
        return e.reduce((e, n) => ((e[n] = t), e), {});
    };

    var Ee = function (e) {
        return JSON.parse(JSON.stringify(e));
    };

    var Te = function (e) {
        return Object.prototype.toString.call(e) === '[object Array]' && !e.length;
    };

    var Le = function (e) {
        if (we(e)) return e;
        try {
            return JSON.parse(e);
        } catch (e) {
            return {};
        }
    };

    var Pe = function (e) {
        return void 0 === e || (we(e) ? Me(Object.keys(e), !0) : Re(e));
    };

    var Re = function (e) {
        try {
            const t = JSON.parse(e);
            return Boolean(e) && be(e, 'string') && Me(Object.keys(t), !0);
        } catch (e) {
            return !1;
        }
    };

    var we = function (e) {
        return e !== null && be(e, 'object') && !1 === Array.isArray(e);
    };

    var xe = function () {};
    var Ne = function (e) {
        return be(e, 'function') ? e() : e;
    };

    var Fe = function (e, t) {
        Pe(e) || ye.error(''.concat(t));
    };

    const je = function (e) {
        return Object.keys(e).map((t) => e[t]);
    };

    var Ve = function (e) {
        return je(e).filter((e, t, n) => n.indexOf(e) === t);
    };

    var Ue = function (e) {
        return function () {
            const t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            const n = t.command;
            const i = t.params;
            const r = void 0 === i ? {} : i;
            const a = t.callback;
            const o = void 0 === a ? xe : a;
            if (!n || n.indexOf('.') === -1) throw new Error('[OptIn.execute] Please provide a valid command.');
            try {
                const s = n.split('.');
                const c = e[s[0]];
                const u = s[1];
                if (!c || typeof c[u] !== 'function') throw new Error('Make sure the plugin and API name exist.');
                const l = Object.assign(r, { callback: o });
                c[u].call(c, l);
            } catch (e) {
                ye.error('[execute] Something went wrong: ' + e.message);
            }
        };
    };

    (f.prototype = Object.create(Error.prototype)), (f.prototype.constructor = f);
    var He = 'fetchPermissions';
    var Be = '[OptIn#registerPlugin] Plugin is invalid.';
    (p.Categories = fe), (p.TimeoutError = f);
    const Ge = Object.freeze({ OptIn: p, IabPlugin: _ });
    const Ye = function (e, t) {
        e.publishDestinations = function (n) {
            const i = arguments[1];
            let r = arguments[2];
            try {
                r = typeof r === 'function' ? r : n.callback;
            } catch (e) {
                r = function () {};
            }

            const a = t;
            if (!a.readyToAttachIframePreliminary())
                return void r({ error: 'The destination publishing iframe is disabled in the Visitor library.' });
            if (typeof n === 'string') {
                if (!n.length) return void r({ error: 'subdomain is not a populated string.' });
                if (!(i instanceof Array && i.length)) return void r({ error: 'messages is not a populated array.' });
                let o = !1;
                if (
                    (i.forEach((e) => {
                        typeof e === 'string' && e.length && (a.addMessage(e), (o = !0));
                    }),
                    !o)
                )
                    return void r({ error: 'None of the messages are populated strings.' });
            } else {
                if (!U.isObject(n)) return void r({ error: 'Invalid parameters passed.' });
                const s = n;
                if (typeof (n = s.subdomain) !== 'string' || !n.length) return void r({ error: 'config.subdomain is not a populated string.' });
                const c = s.urlDestinations;
                if (!(c instanceof Array && c.length)) return void r({ error: 'config.urlDestinations is not a populated array.' });
                const u = [];
                c.forEach((e) => {
                    U.isObject(e) && (e.hideReferrer ? e.message && a.addMessage(e.message) : u.push(e));
                });
                !(function e() {
                    u.length &&
                        setTimeout(() => {
                            const t = new Image();
                            const n = u.shift();
                            (t.src = n.url), a.onPageDestinationsFired.push(n), e();
                        }, 100);
                })();
            }

            a.iframe
                ? (r({ message: 'The destination publishing iframe is already attached and loaded.' }), a.requestToProcess())
                : !e.subdomain && e._getField('MCMID')
                ? ((a.subdomain = n),
                  (a.doAttachIframe = !0),
                  (a.url = a.getUrl()),
                  a.readyToAttachIframe()
                      ? (a.iframeLoadedCallbacks.push((e) => {
                            r({
                                message:
                                    'Attempted to attach and load the destination publishing iframe through this API call. Result: ' +
                                    (e.message || 'no result'),
                            });
                        }),
                        a.attachIframe())
                      : r({
                            error: 'Encountered a problem in attempting to attach and load the destination publishing iframe through this API call.',
                        }))
                : a.iframeLoadedCallbacks.push((e) => {
                      r({
                          message:
                              'Attempted to attach and load the destination publishing iframe through normal Visitor API processing. Result: ' +
                              (e.message || 'no result'),
                      });
                  });
        };
    };

    const qe = function e(t) {
        function n(e, t) {
            return (e >>> t) | (e << (32 - t));
        }

        for (
            var i,
                r,
                a = Math.pow,
                o = 2 ** 32,
                s = '',
                c = [],
                u = 8 * t.length,
                l = (e.h = e.h || []),
                d = (e.k = e.k || []),
                f = d.length,
                p = {},
                g = 2;
            f < 64;
            g++
        )
            if (!p[g]) {
                for (i = 0; i < 313; i += g) p[i] = g;
                (l[f] = (g ** 0.5 * o) | 0), (d[f++] = (g ** (1 / 3) * o) | 0);
            }

        for (t += ''; (t.length % 64) - 56; ) t += '\0';
        for (i = 0; i < t.length; i++) {
            if ((r = t.charCodeAt(i)) >> 8) return;
            c[i >> 2] |= r << (((3 - i) % 4) * 8);
        }

        for (c[c.length] = (u / o) | 0, c[c.length] = u, r = 0; r < c.length; ) {
            const m = c.slice(r, (r += 16));
            const h = l;
            for (l = l.slice(0, 8), i = 0; i < 64; i++) {
                const _ = m[i - 15];
                const C = m[i - 2];
                const S = l[0];
                const I = l[4];
                const v =
                    l[7] +
                    (n(I, 6) ^ n(I, 11) ^ n(I, 25)) +
                    ((I & l[5]) ^ (~I & l[6])) +
                    d[i] +
                    (m[i] = i < 16 ? m[i] : (m[i - 16] + (n(_, 7) ^ n(_, 18) ^ (_ >>> 3)) + m[i - 7] + (n(C, 17) ^ n(C, 19) ^ (C >>> 10))) | 0);
                (l = [(v + ((n(S, 2) ^ n(S, 13) ^ n(S, 22)) + ((S & l[1]) ^ (S & l[2]) ^ (l[1] & l[2])))) | 0].concat(l)), (l[4] = (l[4] + v) | 0);
            }

            for (i = 0; i < 8; i++) l[i] = (l[i] + h[i]) | 0;
        }

        for (i = 0; i < 8; i++)
            for (r = 3; r + 1; r--) {
                const D = (l[i] >> (8 * r)) & 255;
                s += (D < 16 ? 0 : '') + D.toString(16);
            }

        return s;
    };

    const We = function (e, t) {
        return (t !== 'SHA-256' && t !== 'SHA256' && t !== 'sha256' && t !== 'sha-256') || (e = qe(e)), e;
    };

    const Xe = function (e) {
        return String(e).trim().toLowerCase();
    };

    const Ke = Ge.OptIn;
    U.defineGlobalNamespace(), (window.adobe.OptInCategories = Ke.Categories);
    const Je = function (t, n, i) {
        function r() {
            S._customerIDsHashChanged = !1;
        }

        function a(e) {
            const t = e;
            return function (e) {
                const n = e || A.location.href;
                try {
                    const i = S._extractParamFromUri(n, t);
                    if (i) return q.parsePipeDelimetedKeyValues(i);
                } catch (e) {}
            };
        }

        function o(e) {
            function t(e, t, n) {
                e && e.match(oe.VALID_VISITOR_ID_REGEX) && (n === T && (b = !0), t(e));
            }

            t(e[T], S.setMarketingCloudVisitorID, T), S._setFieldExpire(N, -1), t(e[w], S.setAnalyticsVisitorID);
        }

        function s(e) {
            (e = e || {}),
                (S._supplementalDataIDCurrent = e.supplementalDataIDCurrent || ''),
                (S._supplementalDataIDCurrentConsumed = e.supplementalDataIDCurrentConsumed || {}),
                (S._supplementalDataIDLast = e.supplementalDataIDLast || ''),
                (S._supplementalDataIDLastConsumed = e.supplementalDataIDLastConsumed || {});
        }

        function c(e) {
            function t(e, t, n) {
                return (n = n ? (n += '|') : n), (n += e + '=' + encodeURIComponent(t));
            }

            function n(e, n) {
                const i = n[0];
                const r = n[1];
                return r != null && r !== F && (e = t(i, r, e)), e;
            }

            const i = e.reduce(n, '');
            return (function (e) {
                const t = q.getTimestampInSeconds();
                return (e = e ? (e += '|') : e), (e += 'TS=' + t);
            })(i);
        }

        function u(e) {
            let t = e.minutesToLive;
            let n = '';
            return (
                (S.idSyncDisableSyncs || S.disableIdSyncs) && (n = n || 'Error: id syncs have been disabled'),
                (typeof e.dpid === 'string' && e.dpid.length) || (n = n || 'Error: config.dpid is empty'),
                (typeof e.url === 'string' && e.url.length) || (n = n || 'Error: config.url is empty'),
                void 0 === t
                    ? (t = 20160)
                    : ((t = parseInt(t, 10)), (isNaN(t) || t <= 0) && (n = n || 'Error: config.minutesToLive needs to be a positive number')),
                { error: n, ttl: t }
            );
        }

        function l() {
            return Boolean(S.configs.doesOptInApply) && !(I.optIn.isComplete && d());
        }

        function d() {
            return S.configs.doesOptInApply && S.configs.isIabContext
                ? I.optIn.isApproved(I.optIn.Categories.ECID) && y
                : I.optIn.isApproved(I.optIn.Categories.ECID);
        }

        function f() {
            [
                ['getMarketingCloudVisitorID'],
                ['setCustomerIDs', void 0],
                ['syncIdentity', void 0],
                ['getAnalyticsVisitorID'],
                ['getAudienceManagerLocationHint'],
                ['getLocationHint'],
                ['getAudienceManagerBlob'],
            ].forEach((e) => {
                const t = e[0];
                const n = e.length === 2 ? e[1] : '';
                const i = S[t];
                S[t] = function (e) {
                    return d() && S.isAllowed() ? i.apply(S, arguments) : (typeof e === 'function' && S._callCallback(e, [n]), n);
                };
            });
        }

        function p() {
            const e = S._getAudienceManagerURLData();
            const t = e.url;
            return S._loadData(E, t, null, e);
        }

        function g(e, t) {
            if (((y = !0), e)) throw new Error('[IAB plugin] : ' + e);
            t && t.gdprApplies && ((v = t.consentString), (D = t.hasConsentChangedSinceLastCmpPull ? 1 : 0)), p(), _();
        }

        function m(e, t) {
            if (((y = !0), e)) throw new Error('[IAB plugin] : ' + e);
            t.gdprApplies && ((v = t.consentString), (D = t.hasConsentChangedSinceLastCmpPull ? 1 : 0)), S.init(), _();
        }

        function h() {
            I.optIn.isComplete &&
                (I.optIn.isApproved(I.optIn.Categories.ECID)
                    ? S.configs.isIabContext
                        ? I.optIn.execute({ command: 'iabPlugin.fetchConsentData', callback: m })
                        : (S.init(), _())
                    : S.configs.isIabContext
                    ? I.optIn.execute({ command: 'iabPlugin.fetchConsentData', callback: g })
                    : (f(), _()));
        }

        function _() {
            I.optIn.off('complete', h);
        }

        if (!i || i.split('').reverse().join('') !== t) throw new Error('Please use `Visitor.getInstance` to instantiate Visitor.');
        var S = this;
        var I = window.adobe;
        var v = '';
        var D = 0;
        var y = !1;
        var b = !1;
        S.version = '5.5.0';
        var A = C;
        const O = A.Visitor;
        (O.version = S.version),
            (O.AuthState = L.AUTH_STATE),
            (O.OptOut = L.OPT_OUT),
            A.s_c_in || ((A.s_c_il = []), (A.s_c_in = 0)),
            (S._c = 'Visitor'),
            (S._il = A.s_c_il),
            (S._in = A.s_c_in),
            (S._il[S._in] = S),
            A.s_c_in++,
            (S._instanceType = 'regular'),
            (S._log = { requests: [] }),
            (S.marketingCloudOrgID = t),
            (S.cookieName = 'AMCV_' + t),
            (S.sessionCookieName = 'AMCVS_' + t);
        let M = {};
        n && n.secureCookie && n.sameSiteCookie && (M = { sameSite: n.sameSiteCookie, secure: n.secureCookie }),
            (S.cookieDomain = S.useLocalStorage ? '' : ee(null, M)),
            (S.loadSSL = !0),
            (S.loadTimeout = 3e4),
            (S.CORSErrors = []),
            (S.marketingCloudServer = S.audienceManagerServer = 'dpm.demdex.net'),
            (S.sdidParamExpiry = 30);
        let k = null;
        var E = 'MC';
        var T = 'MCMID';
        const P = 'MCIDTS';
        const R = 'A';
        var w = 'MCAID';
        const x = 'AAM';
        var N = 'MCAAMB';
        var F = 'NONE';
        const j = function (e) {
            return !Object.prototype[e];
        };

        const V = ae(S);
        (S.FIELDS = L.FIELDS),
            (S.cookieRead = function (e) {
                return S.useLocalStorage ? (e === S.sessionCookieName ? sessionStorage.getItem(e) : localStorage.getItem(e)) : Z.get(e);
            }),
            (S.cookieWrite = function (e, t, n) {
                const i = String(t);
                if (S.useLocalStorage) return e === S.sessionCookieName ? sessionStorage.setItem(e, i) : localStorage.setItem(e, i);
                const r = S.cookieLifetime ? String(S.cookieLifetime).toUpperCase() : '';
                const a = { expires: n, domain: S.cookieDomain, cookieLifetime: r };
                return (
                    S.configs && S.configs.secureCookie && location.protocol === 'https:' && (a.secure = !0),
                    S.configs &&
                        S.configs.sameSiteCookie &&
                        location.protocol === 'https:' &&
                        (a.sameSite = L.SAME_SITE_VALUES[S.configs.sameSiteCookie.toUpperCase()] || 'Lax'),
                    Z.set(e, i, a)
                );
            }),
            (S.removeCookie = function (e) {
                if (S.useLocalStorage) return e === S.sessionCookieName ? sessionStorage.removeItem(e) : localStorage.removeItem(e);
                const t = { domain: S.cookieDomain };
                return (
                    S.configs && S.configs.secureCookie && location.protocol === 'https:' && (t.secure = !0),
                    S.configs &&
                        S.configs.sameSiteCookie &&
                        location.protocol === 'https:' &&
                        (t.sameSite = L.SAME_SITE_VALUES[S.configs.sameSiteCookie.toUpperCase()] || 'Lax'),
                    Z.remove(e, t)
                );
            }),
            (S.resetState = function (e) {
                e ? S._mergeServerState(e) : s();
            }),
            (S._isAllowedDone = !1),
            (S._isAllowedFlag = !1),
            (S.isAllowed = function () {
                return (
                    S._isAllowedDone ||
                        ((S._isAllowedDone = !0), (S.cookieRead(S.cookieName) || S.cookieWrite(S.cookieName, 'T', 1)) && (S._isAllowedFlag = !0)),
                    S.cookieRead(S.cookieName) === 'T' && S.removeCookie(S.cookieName),
                    S._isAllowedFlag
                );
            }),
            (S.setMarketingCloudVisitorID = function (e) {
                S._setMarketingCloudFields(e);
            }),
            (S._use1stPartyMarketingCloudServer = !1),
            (S.getMarketingCloudVisitorID = function (e, t) {
                S.marketingCloudServer && S.marketingCloudServer.indexOf('.demdex.net') < 0 && (S._use1stPartyMarketingCloudServer = !0);
                const n = S._getAudienceManagerURLData('_setMarketingCloudFields');
                const i = n.url;
                return S._getRemoteField(T, i, e, t, n);
            });
        const H = function (e, t) {
            const n = {};
            S.getMarketingCloudVisitorID(() => {
                t.forEach((e) => {
                    n[e] = S._getField(e, !0);
                }),
                    t.indexOf('MCOPTOUT') !== -1
                        ? S.isOptedOut(
                              (t) => {
                                  (n.MCOPTOUT = t), e(n);
                              },
                              null,
                              !0
                          )
                        : e(n);
            }, !0);
        };

        (S.getVisitorValues = function (e, t) {
            const n = {
                MCMID: { fn: S.getMarketingCloudVisitorID, args: [!0], context: S },
                MCOPTOUT: { fn: S.isOptedOut, args: [void 0, !0], context: S },
                MCAID: { fn: S.getAnalyticsVisitorID, args: [!0], context: S },
                MCAAMLH: { fn: S.getAudienceManagerLocationHint, args: [!0], context: S },
                MCAAMB: { fn: S.getAudienceManagerBlob, args: [!0], context: S },
            };
            const i = t && t.length ? U.pluck(n, t) : n;
            t && t.indexOf('MCAID') === -1 ? H(e, t) : $(i, e);
        }),
            (S._currentCustomerIDs = {}),
            (S._customerIDsHashChanged = !1),
            (S._newCustomerIDsHash = ''),
            (S.setCustomerIDs = function (t, n) {
                if (!S.isOptedOut() && t) {
                    if (!U.isObject(t) || U.isObjectEmpty(t)) return !1;
                    S._readVisitor();
                    let i;
                    let a;
                    let o;
                    let s;
                    for (i in t)
                        if (
                            j(i) &&
                            ((S._currentCustomerIDs.dataSources = S._currentCustomerIDs.dataSources || {}),
                            (a = t[i]),
                            (n = a.hasOwnProperty('hashType') ? a.hashType : n),
                            a)
                        )
                            if (e(a) === 'object') {
                                const c = {};
                                if (a.id) {
                                    if (n) {
                                        if (!(s = We(Xe(a.id), n))) return;
                                        (a.id = s), (c.hashType = n);
                                    }

                                    c.id = a.id;
                                }

                                void 0 != a.authState && (c.authState = a.authState), (S._currentCustomerIDs.dataSources[i] = c);
                            } else if (n) {
                                if (!(s = We(Xe(a), n))) return;
                                S._currentCustomerIDs.dataSources[i] = { id: s, hashType: n };
                            } else S._currentCustomerIDs.dataSources[i] = { id: a };
                    const u = S.getCustomerIDs(!0);
                    let l = S._getField('MCCIDH');
                    let d = '';
                    l || (l = 0);
                    for (o in u) {
                        const f = u[o];
                        if (!U.isObjectEmpty(f))
                            for (i in f)
                                j(i) && ((a = f[i]), (d += (d ? '|' : '') + i + '|' + (a.id ? a.id : '') + (a.authState ? a.authState : '')));
                    }

                    (S._newCustomerIDsHash = String(S._hash(d))),
                        S._newCustomerIDsHash !== l && ((S._customerIDsHashChanged = !0), S._mapCustomerIDs(r));
                }
            }),
            (S.syncIdentity = function (t, n) {
                if (!S.isOptedOut() && t) {
                    if (!U.isObject(t) || U.isObjectEmpty(t)) return !1;
                    S._readVisitor();
                    let i;
                    let a;
                    let o;
                    let s;
                    let c;
                    for (i in t)
                        if (
                            j(i) &&
                            ((S._currentCustomerIDs.nameSpaces = S._currentCustomerIDs.nameSpaces || {}),
                            (a = t[i]),
                            (n = a.hasOwnProperty('hashType') ? a.hashType : n),
                            a && e(a) === 'object')
                        ) {
                            const u = {};
                            if (a.id) {
                                if (n) {
                                    if (!(o = We(Xe(a.id), n))) return;
                                    (a.id = o), (u.hashType = n);
                                }

                                u.id = a.id;
                            }

                            void 0 != a.authState && (u.authState = a.authState),
                                a.dataSource &&
                                    ((S._currentCustomerIDs.dataSources = S._currentCustomerIDs.dataSources || {}),
                                    (s = a.dataSource),
                                    (S._currentCustomerIDs.dataSources[s] = u)),
                                (S._currentCustomerIDs.nameSpaces[i] = u);
                        }

                    const l = S.getCustomerIDs(!0);
                    let d = S._getField('MCCIDH');
                    let f = '';
                    d || (d = '0');
                    for (c in l) {
                        const p = l[c];
                        if (!U.isObjectEmpty(p))
                            for (i in p)
                                j(i) && ((a = p[i]), (f += (f ? '|' : '') + i + '|' + (a.id ? a.id : '') + (a.authState ? a.authState : '')));
                    }

                    (S._newCustomerIDsHash = String(S._hash(f))),
                        S._newCustomerIDsHash !== d && ((S._customerIDsHashChanged = !0), S._mapCustomerIDs(r));
                }
            }),
            (S.getCustomerIDs = function (e) {
                S._readVisitor();
                let t;
                let n;
                const i = { dataSources: {}, nameSpaces: {} };
                const r = S._currentCustomerIDs.dataSources;
                for (t in r)
                    j(t) &&
                        ((n = r[t]),
                        n.id &&
                            (i.dataSources[t] || (i.dataSources[t] = {}),
                            (i.dataSources[t].id = n.id),
                            void 0 != n.authState ? (i.dataSources[t].authState = n.authState) : (i.dataSources[t].authState = O.AuthState.UNKNOWN),
                            n.hashType && (i.dataSources[t].hashType = n.hashType)));
                const a = S._currentCustomerIDs.nameSpaces;
                for (t in a)
                    j(t) &&
                        ((n = a[t]),
                        n.id &&
                            (i.nameSpaces[t] || (i.nameSpaces[t] = {}),
                            (i.nameSpaces[t].id = n.id),
                            void 0 != n.authState ? (i.nameSpaces[t].authState = n.authState) : (i.nameSpaces[t].authState = O.AuthState.UNKNOWN),
                            n.hashType && (i.nameSpaces[t].hashType = n.hashType)));
                return e ? i : i.dataSources;
            }),
            (S.setAnalyticsVisitorID = function (e) {
                S._setAnalyticsFields(e);
            }),
            (S.getAnalyticsVisitorID = function (e, t, n) {
                if (!q.isTrackingServerPopulated() && !n) return S._callCallback(e, ['']), '';
                let i = '';
                if (
                    (n ||
                        (i = S.getMarketingCloudVisitorID((t) => {
                            S.getAnalyticsVisitorID(e, !0);
                        })),
                    i || n)
                ) {
                    let r = n ? S.marketingCloudServer : S.trackingServer;
                    let a = '';
                    S.loadSSL &&
                        (n
                            ? S.marketingCloudServerSecure && (r = S.marketingCloudServerSecure)
                            : S.trackingServerSecure && (r = S.trackingServerSecure));
                    const o = {};
                    if (r) {
                        const s = 'http' + (S.loadSSL ? 's' : '') + '://' + r + '/id';
                        const c = S.configs.cookieLifetime;
                        const u =
                            'd_visid_ver=' +
                            S.version +
                            '&mcorgid=' +
                            encodeURIComponent(S.marketingCloudOrgID) +
                            (i ? '&mid=' + encodeURIComponent(i) : '') +
                            (c ? '&cl=' + encodeURIComponent(c) : '') +
                            (S.idSyncDisable3rdPartySyncing || S.disableThirdPartyCookies ? '&d_coppa=true' : '');
                        const l = ['s_c_il', S._in, '_set' + (n ? 'MarketingCloud' : 'Analytics') + 'Fields'];
                        (a = s + '?' + u + '&callback=s_c_il%5B' + S._in + '%5D._set' + (n ? 'MarketingCloud' : 'Analytics') + 'Fields'),
                            (o.corsUrl = s + '?' + u),
                            (o.callback = l);
                    }

                    return (o.url = a), S._getRemoteField(n ? T : w, a, e, t, o);
                }

                return '';
            }),
            (S.getAudienceManagerLocationHint = function (e, t) {
                if (
                    S.getMarketingCloudVisitorID((t) => {
                        S.getAudienceManagerLocationHint(e, !0);
                    })
                ) {
                    let n = S._getField(w);
                    if (
                        (!n &&
                            q.isTrackingServerPopulated() &&
                            (n = S.getAnalyticsVisitorID((t) => {
                                S.getAudienceManagerLocationHint(e, !0);
                            })),
                        n || !q.isTrackingServerPopulated())
                    ) {
                        const i = S._getAudienceManagerURLData();
                        const r = i.url;
                        return S._getRemoteField('MCAAMLH', r, e, t, i);
                    }
                }

                return '';
            }),
            (S.getLocationHint = S.getAudienceManagerLocationHint),
            (S.getAudienceManagerBlob = function (e, t) {
                if (
                    S.getMarketingCloudVisitorID((t) => {
                        S.getAudienceManagerBlob(e, !0);
                    })
                ) {
                    let n = S._getField(w);
                    if (
                        (!n &&
                            q.isTrackingServerPopulated() &&
                            (n = S.getAnalyticsVisitorID((t) => {
                                S.getAudienceManagerBlob(e, !0);
                            })),
                        n || !q.isTrackingServerPopulated())
                    ) {
                        const i = S._getAudienceManagerURLData();
                        const r = i.url;
                        return S._customerIDsHashChanged && S._setFieldExpire(N, -1), S._getRemoteField(N, r, e, t, i);
                    }
                }

                return '';
            }),
            (S._supplementalDataIDCurrent = ''),
            (S._supplementalDataIDCurrentConsumed = {}),
            (S._supplementalDataIDLast = ''),
            (S._supplementalDataIDLastConsumed = {}),
            (S.getSupplementalDataID = function (e, t) {
                S._supplementalDataIDCurrent || t || (S._supplementalDataIDCurrent = S._generateID(1));
                let n = S._supplementalDataIDCurrent;
                return (
                    S._supplementalDataIDLast && !S._supplementalDataIDLastConsumed[e]
                        ? ((n = S._supplementalDataIDLast), (S._supplementalDataIDLastConsumed[e] = !0))
                        : n &&
                          (S._supplementalDataIDCurrentConsumed[e] &&
                              ((S._supplementalDataIDLast = S._supplementalDataIDCurrent),
                              (S._supplementalDataIDLastConsumed = S._supplementalDataIDCurrentConsumed),
                              (S._supplementalDataIDCurrent = n = t ? '' : S._generateID(1)),
                              (S._supplementalDataIDCurrentConsumed = {})),
                          n && (S._supplementalDataIDCurrentConsumed[e] = !0)),
                    n
                );
            });
        let B = !1;
        (S._liberatedOptOut = null),
            (S.getOptOut = function (e, t) {
                const n = S._getAudienceManagerURLData('_setMarketingCloudFields');
                const i = n.url;
                if (d()) return S._getRemoteField('MCOPTOUT', i, e, t, n);
                if ((S._registerCallback('liberatedOptOut', e), S._liberatedOptOut !== null))
                    return S._callAllCallbacks('liberatedOptOut', [S._liberatedOptOut]), (B = !1), S._liberatedOptOut;
                if (B) return null;
                B = !0;
                const r = 'liberatedGetOptOut';
                return (
                    (n.corsUrl = n.corsUrl.replace(/\.demdex\.net\/id\?/, '.demdex.net/optOutStatus?')),
                    (n.callback = [r]),
                    (C[r] = function (e) {
                        if (e === Object(e)) {
                            var t;
                            let n;
                            const i = U.parseOptOut(e, t, F);
                            (t = i.optOut),
                                (n = 1e3 * i.d_ottl),
                                (S._liberatedOptOut = t),
                                setTimeout(() => {
                                    S._liberatedOptOut = null;
                                }, n);
                        }

                        S._callAllCallbacks('liberatedOptOut', [t]), (B = !1);
                    }),
                    V.fireCORS(n),
                    null
                );
            }),
            (S.isOptedOut = function (e, t, n) {
                t || (t = O.OptOut.GLOBAL);
                const i = S.getOptOut((n) => {
                    const i = n === O.OptOut.GLOBAL || n.indexOf(t) >= 0;
                    S._callCallback(e, [i]);
                }, n);
                return i ? i === O.OptOut.GLOBAL || i.indexOf(t) >= 0 : null;
            });
        const G = { subscribed: !1, callbacks: [] };
        (S.onReceiveEcid = function (e) {
            if (d()) return S.getMarketingCloudVisitorID(e, !0);
            (G.subscribed = !0), e && typeof e === 'function' && G.callbacks.push(e);
        }),
            (S._fields = null),
            (S._fieldsExpired = null),
            (S._hash = function (e) {
                let t;
                let n;
                let i = 0;
                if (e) for (t = 0; t < e.length; t++) (n = e.charCodeAt(t)), (i = (i << 5) - i + n), (i &= i);
                return i;
            }),
            (S._generateID = re),
            (S._generateLocalMID = function () {
                const e = S._generateID(0);
                return (X.isClientSideMarketingCloudVisitorID = !0), e;
            }),
            (S._callbackList = null),
            (S._callCallback = function (e, t) {
                try {
                    typeof e === 'function' ? e.apply(A, t) : e[1].apply(e[0], t);
                } catch (e) {}
            }),
            (S._registerCallback = function (e, t) {
                t &&
                    (S._callbackList == null && (S._callbackList = {}),
                    void 0 == S._callbackList[e] && (S._callbackList[e] = []),
                    S._callbackList[e].push(t));
            }),
            (S._callAllCallbacks = function (e, t) {
                if (S._callbackList != null) {
                    const n = S._callbackList[e];
                    if (n) for (; n.length > 0; ) S._callCallback(n.shift(), t);
                }
            }),
            (S._addQuerystringParam = function (e, t, n, i) {
                const r = encodeURIComponent(t) + '=' + encodeURIComponent(n);
                const a = q.parseHash(e);
                const o = q.hashlessUrl(e);
                if (o.indexOf('?') === -1) return o + '?' + r + a;
                const s = o.split('?');
                const c = s[0] + '?';
                const u = s[1];
                return c + q.addQueryParamAtLocation(u, r, i) + a;
            }),
            (S._extractParamFromUri = function (e, t) {
                const n = new RegExp('[\\?&#]' + t + '=([^&#]*)');
                const i = n.exec(e);
                if (i && i.length) return decodeURIComponent(i[1]);
            }),
            (S._parseAdobeMcFromUrl = a(oe.ADOBE_MC)),
            (S._parseAdobeMcSdidFromUrl = a(oe.ADOBE_MC_SDID)),
            (S._attemptToPopulateSdidFromUrl = function (e) {
                const n = S._parseAdobeMcSdidFromUrl(e);
                let i = 1e9;
                n && n.TS && (i = q.getTimestampInSeconds() - n.TS),
                    n &&
                        n.SDID &&
                        n.MCORGID === t &&
                        i < S.sdidParamExpiry &&
                        ((S._supplementalDataIDCurrent = n.SDID), (S._supplementalDataIDCurrentConsumed.SDID_URL_PARAM = !0));
            }),
            (S._attemptToPopulateIdsFromUrl = function () {
                const e = S._parseAdobeMcFromUrl();
                if (e && e.TS) {
                    const n = q.getTimestampInSeconds();
                    const i = n - e.TS;
                    if (Math.floor(i / 60) > oe.ADOBE_MC_TTL_IN_MIN || e.MCORGID !== t) return;
                    o(e);
                }
            }),
            (S._mergeServerState = function (e) {
                if (e)
                    try {
                        if (
                            ((e = (function (e) {
                                return q.isObject(e) ? e : JSON.parse(e);
                            })(e)),
                            e[S.marketingCloudOrgID])
                        ) {
                            const t = e[S.marketingCloudOrgID];
                            !(function (e) {
                                q.isObject(e) && S.setCustomerIDs(e);
                            })(t.customerIDs),
                                s(t.sdid);
                        }
                    } catch (e) {
                        throw new Error('`serverState` has an invalid format.');
                    }
            }),
            (S._timeout = null),
            (S._loadData = function (e, t, n, i) {
                (t = S._addQuerystringParam(t, 'd_fieldgroup', e, 1)),
                    (i.url = S._addQuerystringParam(i.url, 'd_fieldgroup', e, 1)),
                    (i.corsUrl = S._addQuerystringParam(i.corsUrl, 'd_fieldgroup', e, 1)),
                    (X.fieldGroupObj[e] = !0),
                    i === Object(i) && i.corsUrl && V.corsMetadata.corsType === 'XMLHttpRequest' && V.fireCORS(i, n, e);
            }),
            (S._clearTimeout = function (e) {
                S._timeout != null && S._timeout[e] && (clearTimeout(S._timeout[e]), (S._timeout[e] = 0));
            }),
            (S._settingsDigest = 0),
            (S._getSettingsDigest = function () {
                if (!S._settingsDigest) {
                    let e = S.version;
                    S.audienceManagerServer && (e += '|' + S.audienceManagerServer),
                        S.audienceManagerServerSecure && (e += '|' + S.audienceManagerServerSecure),
                        (S._settingsDigest = S._hash(e));
                }

                return S._settingsDigest;
            }),
            (S._readVisitorDone = !1),
            (S._readVisitor = function () {
                if (!S._readVisitorDone) {
                    S._readVisitorDone = !0;
                    let e;
                    let t;
                    let n;
                    let i;
                    let r;
                    let a;
                    const o = S._getSettingsDigest();
                    let s = !1;
                    let c = S.cookieRead(S.cookieName);
                    const u = new Date();
                    if (
                        (c || b || S.discardTrackingServerECID || (c = S.cookieRead(oe.FIRST_PARTY_SERVER_COOKIE)),
                        S._fields == null && (S._fields = {}),
                        c && c !== 'T')
                    )
                        for (
                            c = c.split('|'),
                                c[0].match(/^[\-0-9]+$/) && (parseInt(c[0], 10) !== o && (s = !0), c.shift()),
                                c.length % 2 == 1 && c.pop(),
                                e = 0;
                            e < c.length;
                            e += 2
                        )
                            (t = c[e].split('-')),
                                (n = t[0]),
                                (i = c[e + 1]),
                                t.length > 1 ? ((r = parseInt(t[1], 10)), (a = t[1].indexOf('s') > 0)) : ((r = 0), (a = !1)),
                                s && (n === 'MCCIDH' && (i = ''), r > 0 && (r = u.getTime() / 1e3 - 60)),
                                n &&
                                    i &&
                                    (S._setField(n, i, 1),
                                    r > 0 &&
                                        ((S._fields['expire' + n] = r + (a ? 's' : '')),
                                        (u.getTime() >= 1e3 * r || (a && !S.cookieRead(S.sessionCookieName))) &&
                                            (S._fieldsExpired || (S._fieldsExpired = {}), (S._fieldsExpired[n] = !0))));
                    !S._getField(w) &&
                        q.isTrackingServerPopulated() &&
                        (c = S.cookieRead('s_vi')) &&
                        ((c = c.split('|')),
                        c.length > 1 &&
                            c[0].indexOf('v1') >= 0 &&
                            ((i = c[1]),
                            (e = i.indexOf('[')),
                            e >= 0 && (i = i.substring(0, e)),
                            i && i.match(oe.VALID_VISITOR_ID_REGEX) && S._setField(w, i)));
                }
            }),
            (S._appendVersionTo = function (e) {
                const t = 'vVersion|' + S.version;
                const n = e ? S._getCookieVersion(e) : null;
                return n ? te.areVersionsDifferent(n, S.version) && (e = e.replace(oe.VERSION_REGEX, t)) : (e += (e ? '|' : '') + t), e;
            }),
            (S._writeVisitor = function () {
                let e;
                let t;
                let n = S._getSettingsDigest();
                for (e in S._fields)
                    j(e) &&
                        S._fields[e] &&
                        e.substring(0, 6) !== 'expire' &&
                        ((t = S._fields[e]), (n += (n ? '|' : '') + e + (S._fields['expire' + e] ? '-' + S._fields['expire' + e] : '') + '|' + t));
                (n = S._appendVersionTo(n)), S.cookieWrite(S.cookieName, n, 1);
            }),
            (S._getField = function (e, t) {
                return S._fields == null || (!t && S._fieldsExpired && S._fieldsExpired[e]) ? null : S._fields[e];
            }),
            (S._setField = function (e, t, n) {
                S._fields == null && (S._fields = {}), (S._fields[e] = t), n || S._writeVisitor();
            }),
            (S._getFieldList = function (e, t) {
                const n = S._getField(e, t);
                return n ? n.split('*') : null;
            }),
            (S._setFieldList = function (e, t, n) {
                S._setField(e, t ? t.join('*') : '', n);
            }),
            (S._getFieldMap = function (e, t) {
                const n = S._getFieldList(e, t);
                if (n) {
                    let i;
                    const r = {};
                    for (i = 0; i < n.length; i += 2) r[n[i]] = n[i + 1];
                    return r;
                }

                return null;
            }),
            (S._setFieldMap = function (e, t, n) {
                let i;
                let r = null;
                if (t) {
                    r = [];
                    for (i in t) j(i) && (r.push(i), r.push(t[i]));
                }

                S._setFieldList(e, r, n);
            }),
            (S._setFieldExpire = function (e, t, n) {
                const i = new Date();
                i.setTime(i.getTime() + 1e3 * t),
                    S._fields == null && (S._fields = {}),
                    (S._fields['expire' + e] = Math.floor(i.getTime() / 1e3) + (n ? 's' : '')),
                    t < 0
                        ? (S._fieldsExpired || (S._fieldsExpired = {}), (S._fieldsExpired[e] = !0))
                        : S._fieldsExpired && (S._fieldsExpired[e] = !1),
                    n && (S.cookieRead(S.sessionCookieName) || S.cookieWrite(S.sessionCookieName, '1'));
            }),
            (S._findVisitorID = function (t) {
                return (
                    t &&
                        (e(t) === 'object' && (t = t.d_mid ? t.d_mid : t.visitorID ? t.visitorID : t.id ? t.id : t.uuid ? t.uuid : String(t)),
                        t && (t = t.toUpperCase()) === 'NOTARGET' && (t = F),
                        (t && (t === F || t.match(oe.VALID_VISITOR_ID_REGEX))) || (t = '')),
                    t
                );
            }),
            (S._setFields = function (t, n) {
                if ((S._clearTimeout(t), S._loading != null && (S._loading[t] = !1), X.fieldGroupObj[t] && X.setState(t, !1), t === E)) {
                    !0 !== X.isClientSideMarketingCloudVisitorID && (X.isClientSideMarketingCloudVisitorID = !1);
                    let i = S._getField(T);
                    if (!i || S.overwriteCrossDomainMCIDAndAID) {
                        if (!(i = e(n) === 'object' && n.mid ? n.mid : S._findVisitorID(n))) {
                            if (S._use1stPartyMarketingCloudServer && !S.tried1stPartyMarketingCloudServer)
                                return (S.tried1stPartyMarketingCloudServer = !0), void S.getAnalyticsVisitorID(null, !1, !0);
                            i = S._generateLocalMID();
                        }

                        S._setField(T, i);
                    }

                    (i && i !== F) || (i = ''),
                        e(n) === 'object' &&
                            ((n.d_region || n.dcs_region || n.d_blob || n.blob) && S._setFields(x, n),
                            S._use1stPartyMarketingCloudServer && n.mid && S._setFields(R, { id: n.id })),
                        S._callAllCallbacks(T, [i]);
                }

                if (t === x && e(n) === 'object') {
                    let r = 604800;
                    void 0 != n.id_sync_ttl && n.id_sync_ttl && (r = parseInt(n.id_sync_ttl, 10));
                    const a = W.getRegionAndCheckIfChanged(n, r);
                    S._callAllCallbacks('MCAAMLH', [a]);
                    let o = S._getField(N);
                    (n.d_blob || n.blob) && ((o = n.d_blob), o || (o = n.blob), S._setFieldExpire(N, r), S._setField(N, o)),
                        o || (o = ''),
                        S._callAllCallbacks(N, [o]),
                        !n.error_msg && S._newCustomerIDsHash && S._setField('MCCIDH', S._newCustomerIDsHash);
                }

                if (t === R) {
                    let s = S._getField(w);
                    (s && !S.overwriteCrossDomainMCIDAndAID) ||
                        ((s = S._findVisitorID(n)), s ? s !== F && S._setFieldExpire(N, -1) : (s = F), S._setField(w, s)),
                        (s && s !== F) || (s = ''),
                        S._callAllCallbacks(w, [s]);
                }

                if (S.idSyncDisableSyncs || S.disableIdSyncs) W.idCallNotProcesssed = !0;
                else {
                    W.idCallNotProcesssed = !1;
                    const c = {};
                    (c.ibs = n.ibs), (c.subdomain = n.subdomain), W.processIDCallData(c);
                }

                if (n === Object(n)) {
                    let u;
                    let l;
                    d() && S.isAllowed() && (u = S._getField('MCOPTOUT'));
                    const f = U.parseOptOut(n, u, F);
                    (u = f.optOut),
                        (l = f.d_ottl),
                        S._setFieldExpire('MCOPTOUT', l, !0),
                        S._setField('MCOPTOUT', u),
                        S._callAllCallbacks('MCOPTOUT', [u]);
                }
            }),
            (S._loading = null),
            (S._getRemoteField = function (e, t, n, i, r) {
                let a;
                let o = '';
                const s = q.isFirstPartyAnalyticsVisitorIDCall(e);
                const c = { MCAAMLH: !0, MCAAMB: !0 };
                if (d() && S.isAllowed()) {
                    S._readVisitor(), (o = S._getField(e, !0 === c[e]));
                    if (
                        (function () {
                            return (!o || (S._fieldsExpired && S._fieldsExpired[e])) && (!S.disableThirdPartyCalls || s);
                        })()
                    ) {
                        if ((e === T || e === 'MCOPTOUT' ? (a = E) : e === 'MCAAMLH' || e === N ? (a = x) : e === w && (a = R), a))
                            return (
                                !t ||
                                    (S._loading != null && S._loading[a]) ||
                                    (S._loading == null && (S._loading = {}),
                                    (S._loading[a] = !0),
                                    a === x && (D = 0),
                                    S._loadData(
                                        a,
                                        t,
                                        (t) => {
                                            if (!S._getField(e)) {
                                                t && X.setState(a, !0);
                                                let n = '';
                                                e === T ? (n = S._generateLocalMID()) : a === x && (n = { error_msg: 'timeout' }), S._setFields(a, n);
                                            }
                                        },
                                        r
                                    )),
                                S._registerCallback(e, n),
                                o || (t || S._setFields(a, { id: F }), '')
                            );
                    } else
                        o ||
                            (e === T
                                ? (S._registerCallback(e, n), (o = S._generateLocalMID()), S.setMarketingCloudVisitorID(o))
                                : e === w
                                ? (S._registerCallback(e, n), (o = ''), S.setAnalyticsVisitorID(o))
                                : ((o = ''), (i = !0)));
                }

                return (
                    (e !== T && e !== w) || o !== F || ((o = ''), (i = !0)),
                    n && i && S._callCallback(n, [o]),
                    e === T &&
                        G.subscribed &&
                        (G.callbacks &&
                            G.callbacks.length &&
                            G.callbacks.forEach((e) => {
                                S._callCallback(e, [o]);
                            }),
                        (G.subscribed = !1),
                        (G.callbacks.length = 0)),
                    o
                );
            }),
            (S._setMarketingCloudFields = function (e) {
                S._readVisitor(), S._setFields(E, e);
            }),
            (S._mapCustomerIDs = function (e) {
                S.getAudienceManagerBlob(e, !0);
            }),
            (S._setAnalyticsFields = function (e) {
                S._readVisitor(), S._setFields(R, e);
            }),
            (S._setAudienceManagerFields = function (e) {
                S._readVisitor(), S._setFields(x, e);
            }),
            (S._getAudienceManagerURLData = function (e) {
                let t = S.audienceManagerServer;
                let n = '';
                const i = S._getField(T);
                const r = S._getField(N, !0);
                const a = S._getField(w);
                let o = a && a !== F ? '&d_cid_ic=AVID%01' + encodeURIComponent(a) : '';
                if ((S.loadSSL && S.audienceManagerServerSecure && (t = S.audienceManagerServerSecure), t)) {
                    let s;
                    let c;
                    let u;
                    const l = S.getCustomerIDs(!0);
                    if (l)
                        for (c in l) {
                            const d = l[c];
                            if (!U.isObjectEmpty(d)) {
                                const f = c === 'nameSpaces' ? '&d_cid_ns=' : '&d_cid_ic=';
                                for (s in d)
                                    j(s) &&
                                        ((u = d[s]),
                                        (o +=
                                            f +
                                            encodeURIComponent(s) +
                                            '%01' +
                                            encodeURIComponent(u.id ? u.id : '') +
                                            (u.authState ? '%01' + u.authState : '')));
                            }
                        }

                    e || (e = '_setAudienceManagerFields');
                    const p = 'http' + (S.loadSSL ? 's' : '') + '://' + t + '/id';
                    const g =
                        'd_visid_ver=' +
                        S.version +
                        (v && p.indexOf('demdex.net') !== -1 ? '&gdpr=1&gdpr_consent=' + v : '') +
                        (D && p.indexOf('demdex.net') !== -1 ? '&d_cf=' + D : '') +
                        '&d_rtbd=json&d_ver=2' +
                        (!i && S._use1stPartyMarketingCloudServer ? '&d_verify=1' : '') +
                        '&d_orgid=' +
                        encodeURIComponent(S.marketingCloudOrgID) +
                        '&d_nsid=' +
                        (S.idSyncContainerID || 0) +
                        (i ? '&d_mid=' + encodeURIComponent(i) : '') +
                        (S.idSyncDisable3rdPartySyncing || S.disableThirdPartyCookies ? '&d_coppa=true' : '') +
                        (!0 === k ? '&d_coop_safe=1' : !1 === k ? '&d_coop_unsafe=1' : '') +
                        (r ? '&d_blob=' + encodeURIComponent(r) : '') +
                        o;
                    const m = ['s_c_il', S._in, e];
                    return (n = p + '?' + g + '&d_cb=s_c_il%5B' + S._in + '%5D.' + e), { url: n, corsUrl: p + '?' + g, callback: m };
                }

                return { url: n };
            }),
            (S.appendVisitorIDsTo = function (e) {
                try {
                    const t = [
                        [T, S._getField(T)],
                        [w, S._getField(w)],
                        ['MCORGID', S.marketingCloudOrgID],
                    ];
                    return S._addQuerystringParam(e, oe.ADOBE_MC, c(t));
                } catch (t) {
                    return e;
                }
            }),
            (S.appendSupplementalDataIDTo = function (e, t) {
                if (!(t = t || S.getSupplementalDataID(q.generateRandomString(), !0))) return e;
                try {
                    const n = c([
                        ['SDID', t],
                        ['MCORGID', S.marketingCloudOrgID],
                    ]);
                    return S._addQuerystringParam(e, oe.ADOBE_MC_SDID, n);
                } catch (t) {
                    return e;
                }
            });
        var q = {
            parseHash(e) {
                const t = e.indexOf('#');
                return t > 0 ? e.substr(t) : '';
            },
            hashlessUrl(e) {
                const t = e.indexOf('#');
                return t > 0 ? e.substr(0, t) : e;
            },
            addQueryParamAtLocation(e, t, n) {
                const i = e.split('&');
                return (n = n != null ? n : i.length), i.splice(n, 0, t), i.join('&');
            },
            isFirstPartyAnalyticsVisitorIDCall(e, t, n) {
                if (e !== w) return !1;
                let i;
                return (
                    t || (t = S.trackingServer),
                    n || (n = S.trackingServerSecure),
                    !(typeof (i = S.loadSSL ? n : t) !== 'string' || !i.length) && i.indexOf('2o7.net') < 0 && i.indexOf('omtrdc.net') < 0
                );
            },
            isObject(e) {
                return Boolean(e && e === Object(e));
            },
            removeCookie(e) {
                Z.remove(e, { domain: S.cookieDomain });
            },
            isTrackingServerPopulated() {
                return Boolean(S.trackingServer) || Boolean(S.trackingServerSecure);
            },
            getTimestampInSeconds() {
                return Math.round(new Date().getTime() / 1e3);
            },
            parsePipeDelimetedKeyValues(e) {
                return e.split('|').reduce((e, t) => {
                    const n = t.split('=');
                    return (e[n[0]] = decodeURIComponent(n[1])), e;
                }, {});
            },
            generateRandomString(e) {
                e = e || 5;
                for (var t = '', n = 'abcdefghijklmnopqrstuvwxyz0123456789'; e--; ) t += n[Math.floor(Math.random() * n.length)];
                return t;
            },
            normalizeBoolean(e) {
                return e === 'true' || (e !== 'false' && e);
            },
            parseBoolean(e) {
                return e === 'true' || (e !== 'false' && null);
            },
            replaceMethodsWithFunction(e, t) {
                for (const n in e) e.hasOwnProperty(n) && typeof e[n] === 'function' && (e[n] = t);
                return e;
            },
        };
        S._helpers = q;
        var W = se(S, O);
        (S._destinationPublishing = W), (S.timeoutMetricsLog = []);
        var X = {
            isClientSideMarketingCloudVisitorID: null,
            MCIDCallTimedOut: null,
            AnalyticsIDCallTimedOut: null,
            AAMIDCallTimedOut: null,
            fieldGroupObj: {},
            setState(e, t) {
                switch (e) {
                    case E:
                        !1 === t ? !0 !== this.MCIDCallTimedOut && (this.MCIDCallTimedOut = !1) : (this.MCIDCallTimedOut = t);
                        break;
                    case R:
                        !1 === t ? !0 !== this.AnalyticsIDCallTimedOut && (this.AnalyticsIDCallTimedOut = !1) : (this.AnalyticsIDCallTimedOut = t);
                        break;
                    case x:
                        !1 === t ? !0 !== this.AAMIDCallTimedOut && (this.AAMIDCallTimedOut = !1) : (this.AAMIDCallTimedOut = t);
                }
            },
        };
        (S.isClientSideMarketingCloudVisitorID = function () {
            return X.isClientSideMarketingCloudVisitorID;
        }),
            (S.MCIDCallTimedOut = function () {
                return X.MCIDCallTimedOut;
            }),
            (S.AnalyticsIDCallTimedOut = function () {
                return X.AnalyticsIDCallTimedOut;
            }),
            (S.AAMIDCallTimedOut = function () {
                return X.AAMIDCallTimedOut;
            }),
            (S.idSyncGetOnPageSyncInfo = function () {
                return S._readVisitor(), S._getField('MCSYNCSOP');
            }),
            (S.idSyncByURL = function (e) {
                if (!S.isOptedOut()) {
                    const t = u(e || {});
                    if (t.error) return t.error;
                    let n;
                    let i;
                    let r = e.url;
                    const a = encodeURIComponent;
                    const o = W;
                    return (
                        (r = r.replace(/^https:/, '').replace(/^http:/, '')),
                        (n = U.encodeAndBuildRequest(['', e.dpid, e.dpuuid || ''], ',')),
                        (i = ['ibs', a(e.dpid), 'img', a(r), t.ttl, '', n]),
                        o.addMessage(i.join('|')),
                        o.requestToProcess(),
                        'Successfully queued'
                    );
                }
            }),
            (S.idSyncByDataSource = function (e) {
                if (!S.isOptedOut())
                    return e === Object(e) && typeof e.dpuuid === 'string' && e.dpuuid.length
                        ? ((e.url = '//dpm.demdex.net/ibs:dpid=' + e.dpid + '&dpuuid=' + e.dpuuid), S.idSyncByURL(e))
                        : 'Error: config or config.dpuuid is empty';
            }),
            Ye(S, W),
            (S._getCookieVersion = function (e) {
                e = e || S.cookieRead(S.cookieName);
                const t = oe.VERSION_REGEX.exec(e);
                return t && t.length > 1 ? t[1] : null;
            }),
            (S._resetAmcvCookie = function (e) {
                const t = S._getCookieVersion();
                (t && !te.isLessThan(t, e)) || S.removeCookie(S.cookieName);
            }),
            (S.setAsCoopSafe = function () {
                k = !0;
            }),
            (S.setAsCoopUnsafe = function () {
                k = !1;
            }),
            (function () {
                if (((S.configs = Object.create(null)), q.isObject(n))) for (const e in n) j(e) && ((S[e] = n[e]), (S.configs[e] = n[e]));
            })(),
            f();
        let K;
        S.init = function () {
            (l() && (I.optIn.fetchPermissions(h, !0), !I.optIn.isApproved(I.optIn.Categories.ECID))) ||
                K ||
                ((K = !0),
                (function () {
                    if (q.isObject(n)) {
                        (S.idSyncContainerID = S.idSyncContainerID || 0),
                            (k = typeof S.isCoopSafe === 'boolean' ? S.isCoopSafe : q.parseBoolean(S.isCoopSafe)),
                            S.resetBeforeVersion && S._resetAmcvCookie(S.resetBeforeVersion),
                            S._attemptToPopulateIdsFromUrl(),
                            S._attemptToPopulateSdidFromUrl(),
                            S._readVisitor();
                        const e = S._getField(P);
                        const t = Math.ceil(new Date().getTime() / oe.MILLIS_PER_DAY);
                        S.idSyncDisableSyncs || S.disableIdSyncs || !W.canMakeSyncIDCall(e, t) || (S._setFieldExpire(N, -1), S._setField(P, t)),
                            S.getMarketingCloudVisitorID(),
                            S.getAudienceManagerLocationHint(),
                            S.getAudienceManagerBlob(),
                            S._mergeServerState(S.serverState);
                    } else S._attemptToPopulateIdsFromUrl(), S._attemptToPopulateSdidFromUrl();
                })(),
                (function () {
                    if (!S.idSyncDisableSyncs && !S.disableIdSyncs) {
                        W.checkDPIframeSrc();
                        const e = function () {
                            const e = W;
                            e.readyToAttachIframe() && e.attachIframe();
                        };

                        A.addEventListener('load', () => {
                            (O.windowLoaded = !0), e();
                        });
                        try {
                            ie.receiveMessage((e) => {
                                W.receiveMessage(e.data);
                            }, W.iframeHost);
                        } catch (e) {}
                    }
                })(),
                (function () {
                    S.whitelistIframeDomains &&
                        oe.POST_MESSAGE_ENABLED &&
                        ((S.whitelistIframeDomains =
                            S.whitelistIframeDomains instanceof Array ? S.whitelistIframeDomains : [S.whitelistIframeDomains]),
                        S.whitelistIframeDomains.forEach((e) => {
                            const n = new Y(t, e);
                            const i = Q(S, n);
                            ie.receiveMessage(i, e);
                        }));
                })());
        };
    };

    (Je.config = ue), (C.Visitor = Je);
    const ze = Je;
    const Qe = function (e) {
        if (U.isObject(e))
            return Object.keys(e)
                .filter((t) => e[t] !== '' && ue.getConfigs()[t])
                .reduce((t, n) => {
                    const i = ue.normalizeConfig(n, e[n]);
                    const r = U.normalizeBoolean(i);
                    return (t[n] = r), t;
                }, Object.create(null));
    };

    const $e = Ge.OptIn;
    const Ze = Ge.IabPlugin;
    return (
        (ze.getInstance = function (e, t) {
            if (!e) throw new Error('Visitor requires Adobe Marketing Cloud Org ID.');
            e.indexOf('@') < 0 && (e += '@AdobeOrg');
            const n = (function () {
                const t = C.s_c_il;
                if (t)
                    for (let n = 0; n < t.length; n++) {
                        const i = t[n];
                        if (i && i._c === 'Visitor' && i.marketingCloudOrgID === e) return i;
                    }
            })();
            if (n) return n;
            const i = Qe(t) || {};
            !(function (e) {
                C.adobe.optIn =
                    C.adobe.optIn ||
                    (function () {
                        const t = U.pluck(e, [
                            'doesOptInApply',
                            'previousPermissions',
                            'preOptInApprovals',
                            'isOptInStorageEnabled',
                            'optInStorageExpiry',
                            'isIabContext',
                            'sameSiteCookie',
                            'secureCookie',
                        ]);
                        let n = e.optInCookieDomain || e.cookieDomain;
                        (n = n || ee()), (n = n === window.location.hostname ? '' : n), (t.optInCookieDomain = n);
                        const i = new $e(t, { cookies: Z });
                        if (t.isIabContext && t.doesOptInApply) {
                            const r = new Ze();
                            i.registerPlugin(r);
                        }

                        return i;
                    })();
            })(i || {});

            const r = e;
            const a = r.split('').reverse().join('');
            let o = new ze(e, null, a);
            i.cookieDomain && (o.cookieDomain = i.cookieDomain),
                i.sameSiteCookie && i.secureCookie && (o.configs = { sameSiteCookie: i.sameSiteCookie, secureCookie: i.secureCookie }),
                (function () {
                    C.s_c_il.splice(--C.s_c_in, 1);
                })();
            const s = U.getIeVersion();
            if (typeof s === 'number' && s < 10) return o._helpers.replaceMethodsWithFunction(o, () => {});
            const c =
                (function () {
                    try {
                        return C.self !== C.parent;
                    } catch (e) {
                        return !0;
                    }
                })() &&
                (!(function (e) {
                    return (
                        e.cookieWrite('TEST_AMCV_COOKIE', 'T', 1),
                        e.cookieRead('TEST_AMCV_COOKIE') === 'T' && (e.removeCookie('TEST_AMCV_COOKIE'), !0)
                    );
                })(o) ||
                    (U.isFirefox() &&
                        !(function (t) {
                            const n = 'AMCV_' + e;
                            return Boolean(t.cookieRead(n));
                        })(o) &&
                        i.whitelistParentDomain)) &&
                C.parent
                    ? new W(e, i, o, C.parent)
                    : new ze(e, i, a);
            return (o = null), c.init(), c;
        }),
        (function () {
            function e() {
                ze.windowLoaded = !0;
            }

            C.addEventListener ? C.addEventListener('load', e) : C.attachEvent && C.attachEvent('onload', e), (ze.codeLoadEnd = new Date().getTime());
        })(),
        ze
    );
})();

// Espone Visitor come globale
if (typeof window !== 'undefined' && typeof Visitor !== 'undefined') {
    window.Visitor = Visitor;
}
